<template>
<div>
    <div class="componentTop">
        <div class="componentText">课程内容</div>
        <div style="padding: 0 0 0 15px">
            <a-button
                v-if="currentHostname !== 'study.gzteacher.com'"
                style="background: #49D292;color: #fff;margin-right:10px;"
                @click="updateVideoExpertNameBatch()">批量修改专家</a-button>
            <a-button
                v-if="currentHostname !== 'study.gzteacher.com' && appUtils.getReaserchInfo().isAuto == 'Y'"
                style="background: #49D292;color: #fff;margin-right:10px;"
                @click="autoBuildLesson()">自动建课</a-button>
        </div>

    </div>
    <draggable
        class="list-group"
        tag="div"
        v-model="activityArr"
        v-bind="dragOptions"
        @start="drag = true"
        @end="changedrag"
        handle=".handle"
    >
        <!-- 遍历 -->
        <div v-for="(item, index) in activityArr" class="section">
            <div class="sectionWrap dfrn">
                <div class="sectionLeft df">
                    <a-icon @click="togDetail(item)" v-show="!item.showDetail" class="cp" type="right" />
                    <a-icon @click="togDetail(item)" v-show="item.showDetail" class="cp" type="down" />
                    <span class="w5p"></span>
                    <span>
                        <a-checkbox @change="(flag) => {changecheckbox(1, item, flag)}" v-model="item.checkbox" class="draggablecheckbox" ></a-checkbox>{{ item.activityName }}
                    </span>
                </div>
                <div class="sectionRight dfrn">
                    <a-button @click="addAct(item.activityId)">创建节名称</a-button>
                    <a-button @click="addTask(item.activityId)">添加活动</a-button>
                    <a-icon @click="editAct(item)" class="cp" type="edit" />
                    <a-divider type="vertical" />
                    <a-icon @click="delAct(item)" class="cp" type="delete" />
                    <a-divider type="vertical" />
                    <a-icon class="handle cp" type="drag" />
                </div>
            </div>
            <draggable
                class="list-group"
                tag="div"
                v-model="item.activityTasks"
                v-bind="dragOptions1"
                :group="item.activityId"
                @start="drag = true"
                @end="changedrag1(item)"
                handle=".handle1"
                v-show="item.activityTasks.length > 0 && item.showDetail"
            >
                <!-- 遍历 -->
                <div v-for="(item1, index1) in item.activityTasks" >
                    <div v-show="item1.isDisplay == 'Y'" class="sectionWrap dfrn taskWrap">
                        <div class="sectionLeft df">
                            <a-icon @click="togDetail(item1)" v-show="!item1.showDetail" class="cp" type="right" />
                            <a-icon @click="togDetail(item1)" v-show="item1.showDetail" class="cp" type="down" />
                            <span class="w5p"></span>
                            <span><a-checkbox @change="(flag) => {changecheckbox(2, item1, flag)}" v-model="item1.checkbox" class="draggablecheckbox"></a-checkbox>{{ item1.taskName }}</span>
                        </div>
                        <div class="sectionRight dfrn">
                            <a-icon @click="addTask(item.activityId, item1.taskId)" class="cp" type="plus" />
                            <a-icon @click="editAct(item1)" class="cp" type="edit" />
                            <a-icon @click="delAct1(item1)" class="cp" type="delete" />
                            <a-icon class="handle1 cp" type="drag" />
                        </div>
                    </div>
                    <div v-if="item1.isDisplay == 'N' && item1.taskActList.length > 0" class="sectionWrap dfrn taskWrap" style="background-color: #fff;">
                        <div class="df">
                            <a-checkbox @change="(flag) => {changecheckbox(2, item1, flag)}" v-model="item1.taskActList[0].checkbox" class="draggablecheckbox1"></a-checkbox>
                            <img :src="require(`./../../../../static/images/s_${item1.taskActList[0].actTypeId}.png`)" width="24px" height="24px" alt="">
                            <span class="isDisplayN">
                                【{{item1.taskActList[0].actTypeName}}】{{ item1.taskActList[0].actName }}
                            </span>
                            <span v-if="item1.taskActList[0].isRequired == 'Y'" style="border-radius: 4px;display: inline-block;line-height: 22px;background-color: #7e90ce;width: 43px;height: 24px;color:white;display">必修</span>
                        </div>
                        <div class="sectionRight dfrn">
                            <a-icon @click="editAct1(item1.taskActList[0], item1)" class="cp" type="edit" />
                            <a-icon @click="delAct3(item1.taskActList[0], item1)" class="cp" type="delete" />
                            <a-icon class="handle1 cp" type="drag" />
                        </div>
                    </div>
                    <draggable
                        class="list-group"
                        tag="div"
                        v-model="item1.taskActList"
                        v-bind="dragOptions2"
                        :group="item1.taskId"
                        @start="drag = true"
                        @end="changedrag2(item1, index1, index)"
                        handle=".handle2"
                        v-show="item1.taskActList.length > 0 && item1.showDetail && item1.isDisplay == 'Y'"
                    >
                        <div v-for="(item2, index2) in item1.taskActList" v-if="item1.isDisplay == 'Y' && item.activityTasks.length > 0" class="sectionWrap dfrn taskWrap1">
                            <div class="df">
                                <a-checkbox @change="(flag) => {changecheckbox(4, item2, flag)}" v-model="item2.checkbox" class="draggablecheckbox1"></a-checkbox>
                                <img :src="require(`./../../../../static/images/s_${item2.actTypeId}.png`)" width="24px" height="24px" alt="">
                                <span class="isDisplayN">
                                    【{{item2.actTypeName}}】{{ item2.actName }}
                                </span>
                                <span v-if="item2.isRequired == 'Y'" style="border-radius: 4px;display: inline-block;line-height: 22px;background-color: #7e90ce;width: 43px;height: 24px;color:white;display">必修</span>
                            </div>
                            <div class="sectionRight dfrn">
                                <a-icon @click="editAct1(item2, item1)" class="cp" type="edit" />
                                <a-icon @click="delAct2(item2)" class="cp" type="delete" />
                                <a-icon class="handle2 cp" type="drag" />
                            </div>
                        </div>
                    </draggable>
                    <div class="emptyWrap dfc" v-show="item1.taskActList.length == 0 && item1.showDetail" style="margin: 0 27px 0 45px;border-bottom: 1px solid rgb(233, 233, 233);">
                        <a-icon type="smile" />
                        <span class="w5p"></span>
                        <span>本节还没有内容，请点击“+”图标添加内容</span>
                    </div>
                </div>
            </draggable>
            <div class="emptyWrap dfc" v-show="item.activityTasks.length == 0 && item.showDetail">
                <a-icon type="smile" />
                <span class="w5p"></span>
                <span>本章还没有内容，请“创建节名称”或“添加活动”</span>
            </div>
        </div>
    </draggable>
    <div class="actWrap">
        <div class="actAdd" @click="addAct(false)">
            <a-icon type="plus" />
            创建章名称
        </div>
    </div>

    <a-modal
        :title="title"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
    >
        <addNewActivity
            ref="addNewAct"
            :labelName="labelName"
            :placeholder="placeholder"
            :addNewText="addNewText"
            :isEdit="isEdit"
            @handleOk="handleOk"
        >
        </addNewActivity>
    </a-modal>

    <a-modal class="actAddWrap" title="添加活动" v-model="addActShow" @ok="hideModal">
        <div class="actAddText">
            内容学习
        </div>
        <div class="actAddList">
            <actIcon :actData="actTypeIdArr.ACT002" @thisClick="showActInfo"></actIcon>
            <actIcon :actData="actTypeIdArr.ACT007" @thisClick="showActInfo"></actIcon>
            <actIcon :actData="actTypeIdArr.ACT003" @thisClick="showActInfo"></actIcon>
            <actIcon :actData="actTypeIdArr.ACT005" @thisClick="showActInfo"></actIcon>
            <actIcon :actData="actTypeIdArr.ACT001" @thisClick="showActInfo"></actIcon>
        </div>
        <!-- <div class="actAddText">
            互动学习
        </div>
        <div class="actAddList">
            <actIcon :actData="actTypeIdArr.ACT003" @thisClick="showActInfo"></actIcon>
        </div> -->
    </a-modal>


    <a-drawer
      :title="actInfoShowtitle"
      :width="880"
      @close="onClose"
      :visible="actInfoShow"
      :maskClosable="false"
      :bodyStyle="{ paddingBottom: '80px' }"
    >

        <div>
            <actForm
                ref="actInfo"
                :actTypeId="actTypeId"
                :actTypeName='actTypeName'
                :actDesc='actDesc'
                :expertName='expertName'
                :actName='actName'
                :isRequired='isRequired'
                :type='thistype'
            ></actForm>
            <div v-show="popShowhttl">
                <a-form-item label="讨论内容" class="requiredForm">
                    <a-textarea
                        v-model="httlDesc"
                        placeholder="请输入本主题讨论的内容（不超过500字）"
                        :maxLength="500"
                        :autoSize="{ minRows: 3, maxRows: 5 }"
                    />
                </a-form-item>
            </div>
            <div v-if="popShowwjdc">
                <a-form-item label="问卷内容" class="requiredForm" style="margin-bottom: 0px;">
                    <a-button @click="downloadWJDC"><a-icon type="download" />下载附件</a-button>
                    <span v-html="'&emsp;'"></span>
                    <a-upload
                        :accept="'.doc, .docx, .excel, .ppt, .pptx, .xls, .xlsx, .pdf, .txt'"
                        :action="apis.coursedetail.excelImport"
                        :transformFile="transformFile"
                        :beforeUpload="beforeUploadVideoExcelImport"
                        :fileList="fileListVideoExcelImport"
                        @change="fileListVideoExcelImport1"
                        :showUploadList="false"
                        :remove="removeFile"
                        :headers="{
                            'Authorization': 'Bearer ' + appUtils.getToken()
                        }"
                    >
                        <div class="uploadBtn df">
                            <a-button type="primary" style="margin-right: 0px;"><a-icon type="upload" />上传文件</a-button>
                        </div>
                    </a-upload>
                    <span v-html="'&emsp;'"></span>
                    <a-button type="primary" :disabled="voteImportDisable" @click="showVoteSubjectList"><a-icon type="file-search" />问卷预览</a-button>
                    <!-- <a-button type="primary" @click="showVoteSubjectList"><a-icon type="file-search" />问卷预览</a-button> -->
                </a-form-item>
                <span style="color: red;">注意：多次上传文件，只会保存最新的问卷内容，原有的内容都会被删除！</span>
            </div>
            <div v-if="popShowtzyd">
                <a-form-item label="资料地址" class="requiredForm" v-if="appUtils.getReaserchInfo().isAuto == 'N'">
                    <a-input v-model="fileListVideoUrl" placeholder="请上传文件" disabled/>
                    <a-upload
                        :accept="'.doc, .docx, .excel, .ppt, .pptx, .xls, .xlsx, .pdf, .txt'"
                        :action="apis.upload.apiUpload+appUtils.getResearchId()"
                        :transformFile="transformFile"
                        :beforeUpload="beforeUploadVideo"
                        :fileList="fileListVideo"
                        @change="changeUploadVideo"
                        :remove="removeFile"
                    >
                        <!-- :customRequest="customRequest" -->
                        <div class="uploadBtn df">
                            <a-button> <a-icon type="upload" />上传材料</a-button><a-button @click="previewFile" type="primary" v-if="appUtils.getReaserchInfo().isAuto == 'N'">在线预览</a-button>
                        </div>
                    </a-upload>
                </a-form-item>
                <span v-if="appUtils.getReaserchInfo().isAuto == 'N'">说明：上传材料的最大不超过50M，只支持word、excel、ppt、pdf、txt类型的文档上传</span>
                <div class="uploadBtn">
                    <a-button @click="getResource1" v-if="appUtils.getReaserchInfo().isAuto == 'Y'">从资源库获取</a-button>
                    <!-- <a-button @click="getResource1">从资源库获取</a-button> -->

                    <a-button @click="previewFile" type="primary" v-if="appUtils.getReaserchInfo().isAuto == 'Y'">在线预览</a-button>
                    <div v-if="appUtils.getReaserchInfo().isAuto == 'Y'">
                        <br/><br/>
                        文件名：{{filename}}
                    </div>
                    <!-- <div>
                        <br/><br/>
                        文件名：{{filename}}
                    </div> -->
                </div>
            </div>
            <div v-if="popShowwlxx">
                <a-form-item label="外链方式" class="requiredForm">
                    <a-radio-group v-model="linkType" name="playSubject" :default-value="'1'">
                        <a-radio value="1">
                            嵌入至学习平台
                        </a-radio>
                        <a-radio value="2">
                            打开浏览器新窗口
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="外链地址" class="requiredForm">
                    <a-input
                        v-model="popShowwlxxUrl"
                        placeholder="请填写外链地址，需包括连接头部，如http://"
                        :autoSize="{ minRows: 3, maxRows: 5 }"
                    />
                    <div>
                        <span style="color: #FF3333;">注意：外链地址若是视频，音频，下载文件的地址等，不一定可以直接播放或下载，和用户打开链接的浏览器有关，请知悉！需包括连接头部，如http://</span>
                    </div>
                </a-form-item>
            </div>
            <div v-show="popShowspxx">
                <a-form-item label="视频提要" style="margin: 40px 0;">
                    <span>说明：上传视频提要后，学员将在观看视频前，需浏览提要才能看视频。</span>
                    <br>
                    <a-upload
                        :accept="'.jpg, .png, .ppt, .pptx, .xls, .xlsx, .doc, .docx, .pdf'"
                        :action="apis.upload.apiUpload+appUtils.getResearchId()"
                        :transformFile="transformFile"
                        :beforeUpload="beforeUploadVideo11"
                        :fileList="fileListVideo"
                        @change="changeUploadVideo"
                        :remove="removeFile1"
                        @preview="previewFile"
                    >
                        <div class="uploadBtn df" style="margin: 0px 0;">
                            <a-button> <a-icon type="upload" />上传文件</a-button>
                        </div>
                    </a-upload>
                    <span>仅支持jpg、png、ppt、pptx、xls、xlsx、doc、docx、pdf格式，文件大小不超过10M。</span>
                    <br><br>
                    <div>
                        <a-input
                            type="number"
                            class="w60 db mab10"
                            v-model="summaryTime"
                            :addonBefore="'视频提要需观看'"
                            :addonAfter="'秒'"
                            defaultValue="10"
                            :disabled="fileListVideoUrl == ''"
                        />
                        <span>说明：观看指定的时长后，视频自动播放，当没有上传文件时，这个设置不生效</span>
                    </div>
                </a-form-item>
                <a-form-item label="视频&题目">
                    <a-form-item label="上传视频" class="requiredForm" v-if="appUtils.getReaserchInfo().isAuto == 'N'">
                        <a-upload
                            :accept="'.mp4, .wmv, .avi, .rmvb'"
                            :beforeUpload="beforeUploadVideo1"
                            @change="changeUploadVideo1"
                            :fileList="fileListVideo1"
                        >
                            <div class="uploadBtn df">
                                <a-button> <a-icon type="upload" />上传视频</a-button>
                            </div>
                        </a-upload>
                        <a-progress v-show="uploadPercent != 0" :percent="uploadPercent" :show-info="false" />
                        <span>说明：仅支持mp4、wmv、avi、rmvb格式的视频上传，大小不超过3000Mb</span>
                    </a-form-item>
                    <div class="uploadBtn" v-if="appUtils.getReaserchInfo().isAuto == 'Y'">
                        <a-button @click="getResource">从资源库获取</a-button>
                    </div>

                    是否显示出题点:
                    <a-radio-group v-model="playSubject" name="playSubject" :default-value="'Y'">
                        <a-radio value="Y">
                            显示
                        </a-radio>
                        <a-radio value="N">
                            不显示
                        </a-radio>
                    </a-radio-group>
                    <div>
                        <div id="a-opt" v-if="playerShow">
                            <div class="prism-player" id="J_prismPlaye"></div>
                        </div>
                        <div v-if="playerShowplayerShow">
                            <img width="832px" height="500px" src="http://file.gzedu.com/upload/downloadFile.do?uploadInfoId=3123f9e6eea74e38803a905441e9e88f" alt="">
                        </div>
                        <!-- <video
                            ref="video"
                            :src="'http://cdn-res.ttcn.cn/file2/37d7f51aebcc4a9c86bd73d7cfccf92aLD.mp4'"
                            width="615px"
                            height="350px"
                            controls="controls"
                        >
                        </video> -->
                    </div>
                    <div>
                        当前播放时间： {{ videoNowTime.result || '00:00:00.000' }}秒
                    </div>
                    <a-button @click="chooseQuestion" type="primary">
                        从题库中选题
                    </a-button>
                    <a-button @click="()=> courseQuestionBankvisible = true" style="margin-left:10px;">
                        创建视频题目
                    </a-button>
                </a-form-item>
                <div class="questionList">
                    <div class="questionListTop dfrn">
                        <div class="w10">
                            序号
                        </div>
                        <div class="w30">
                            题目
                        </div>
                        <div class="w10">
                            题型
                        </div>
                        <div class="w30">
                            弹出时间点
                        </div>
                        <div class="w15">
                            操作
                        </div>
                    </div>
                    <draggable
                        class="list-group"
                        tag="div"
                        v-model="questionListList"
                        v-bind="dragOptions3"
                        @start="drag = true"
                        handle=".handle3"
                    >
                        <!-- <div v-if="questionListList.length == 0">
                            <a-button @click="delQuestionAll" type="primary">
                                重新选择题目
                            </a-button>
                        </div> -->
                        <div v-if="questionListList.length > 0" v-for="(item, index) in questionListList" class="questionListList dfrn">
                            <div class="w10">
                                {{ index + 1 }}
                            </div>
                            <div class="w30" style="text-align:left;">
                                {{ item.qastoreContent }}
                            </div>
                            <div class="w10">
                                {{ item.qastoreType == 'radio' ? '单选题' : '' }}
                                {{ item.qastoreType == 'checkbox' ? '多选题' : '' }}
                                {{ item.qastoreType == 'whether' ? '是非题' : '' }}
                            </div>
                            <div class="w30">
                                <!-- item.videoNowTime -->
                                <a-input v-model="item.h" placeholder="00" style="width: 30px;padding: 0;"/>时
                                <a-input v-model="item.min" placeholder="00" style="width: 30px;padding: 0;"/>分
                                <a-input v-model="item.secondTime" placeholder="00" style="width: 30px;padding: 0;"/>秒
                                <a-input v-model="item.hm" placeholder="000" style="width: 30px;padding: 0;"/>毫秒
                            </div>
                            <div class="w15 dfc" style="padding: 0;">
                                <!-- <a-icon class="handle3 cp" type="drag" style="font-size:20px;" /> -->
                                <a-button @click="delQuestion(index)" type="primary">
                                    删除
                                </a-button>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
            <a-form-item label="完成要求" class="requiredForm" v-if="(typeof demand) == 'string'">
                <a-checkbox defaultChecked disabled>{{ demand }}</a-checkbox>
            </a-form-item>
            <a-form-item label="完成要求" class="requiredForm" v-if="(typeof demand) != 'string'">
                <div class="df" v-for="(item, index) in demand">
                    <a-checkbox v-if="item[2]" v-model="item[2].value" style="margin-bottom: 10px;"></a-checkbox>
                    <span v-if="item[2]" v-html="'&nbsp;'"></span>
                    <a-input
                        type="number"
                        class="w60 db mab10"
                        v-model="item[0].value"
                        :addonBefore="item[0].text.split('·')[0]"
                        :addonAfter="item[0].text.split('·')[1]"
                        defaultValue="0"
                        @change="(e)=>{inputChange(e, item[0])}"
                    />
                    <span v-if="item[1]">&nbsp;，&nbsp;</span>
                    <a-input
                        v-if="item[1]"
                        type="number"
                        class="w60 db mab10"
                        v-model="item[1].value"
                        :addonBefore="item[1].text.split('·')[0]"
                        :addonAfter="item[1].text.split('·')[1]"
                        defaultValue="0"
                        @change="(e)=>{inputChange(e, item[1])}"
                    />
                </div>
            </a-form-item>
            <!-- <a-form-item label="完成要求" class="requiredForm" v-if="(typeof demand) == 'string'">
                <a-checkbox defaultChecked disabled>{{ demand }}</a-checkbox>
            </a-form-item> -->
        </div>
    <!-- </a-modal> -->
        <div
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 10000,
            }"
        >
            <a-button :style="{ marginRight: '8px' }" @click="onClose">
                取消
            </a-button>
            <a-button @click="submitActInfo" type="primary">保存</a-button>
        </div>
    </a-drawer>
    <a-drawer
      title="资源库列表"
      :width="750"
      @close="onClose1"
      :visible="actInfoShow1"
      :bodyStyle="{ padding: '0' }"
    >
        <div style="padding:10px 24px;">只支持word、excel、ppt、pdf、txt、mp4、wmv、avi、rmvb类型的资源</div>
        <div class="resourceList dfrn" style="background-color: #FAFAFA;">
            <div class="resourceLeft">
                资源名称
            </div>
            <div class="resourceRight">
                操作
            </div>
        </div>
        <div v-if="resourceArr.length > 0" v-for="(item, index) in resourceArr" class="resourceList dfrn">
            <div class="resourceLeft">
                {{ item.name }}
            </div>
            <div class="resourceRight">
                <a-button @click="chooseThis(item)">选择</a-button>
            </div>
        </div>
    </a-drawer>
    <a-drawer
      title="选择插题题目"
      :width="750"
      @close="onClose2"
      :visible="actInfoShow2"
      :bodyStyle="{ padding: '0' }"
    >
        <div class="question">
            <div class="dfc questionTop">
                <span>插题时间:</span>
                <a-input v-model="h" type="number"/>
                <span>时</span>
                <a-input v-model="min" type="number"/>
                <span>分</span>
                <a-input v-model="secondTime" type="number" max="60"/>
                <span>秒</span>
                <a-input v-model="hm" type="number" :maxLength="3"/>
                <span>毫秒</span>
            </div>
            <div class="actFormWrap" style="padding: 10px 20px;">
                <div class="w60 dib">
                    <a-form-item label="题干">
                        <a-input v-model="qastoreContent" />
                    </a-form-item>
                </div>
                <div class="w30 dib">
                    <a-form-item label="标签">
                        <a-input v-model="keyWord" />
                    </a-form-item>
                </div>
            </div>
            <div class="actFormWrap" style="padding: 10px 20px;">
                <a-form-item label="题型">
                    <a-select v-model="qastoreType" default-value="radio" style="width: 120px" @change="handleChange">
                        <a-select-option value="">
                            请选择
                        </a-select-option>
                        <a-select-option value="radio">
                            单选题
                        </a-select-option>
                        <a-select-option value="checkbox">
                            多选题
                        </a-select-option>
                        <a-select-option value="whether">
                            是非题
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="排序方式" style="margin-left:15px;">
                    <a-select v-model="sortType" default-value="radio" style="width: 120px" @change="handleChangeSortType">
                        <a-select-option value="">
                            默认
                        </a-select-option>
                        <a-select-option value="qastoreType">
                            标签
                        </a-select-option>
                    </a-select>
                    <a-button @click="searchQastoreList" type="primary" style="margin-left: 20px;width: 100px;">
                        搜索
                    </a-button>
                </a-form-item>
            </div>
            <a-table v-if="actInfoShow2" :pagination="pagination" @change="handleQuestionTableChange" :row-selection="rowSelection" :columns="columns" :data-source="tableData">
                <template slot="qastoreType" slot-scope="qastoreType">
                    {{ qastoreType == 'radio' ? '单选题' : '' }}
                    {{ qastoreType == 'checkbox' ? '多选题' : '' }}
                    {{ qastoreType == 'whether' ? '是非题' : '' }}
                </template>
            </a-table>
        </div>
        <div style="height:60px;"></div>
        <div
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 10000,
            }"
        >
            <a-button :style="{ marginRight: '8px' }" @click="onClose2">
                取消
            </a-button>
            <a-button @click="submitActInfo2" type="primary">确定</a-button>
        </div>
    </a-drawer>
    <a-modal
      title="创建视频题目"
      :visible="courseQuestionBankvisible"
      @ok="courseQuestionBankhandleOk"
      @cancel="courseQuestionBankhandleCancel"
      :width="1100"
    >
        <courseQuestionBank></courseQuestionBank>
    </a-modal>
    <a-modal
      title="调查问卷"
      :visible="returnVoteSubjectListvisible"
      @cancel="returnVoteSubjectListhandleOk"
      :width="1100"
      :footer="null"
    >
        <question
            :voteSubjectList="voteSubjectList"
        ></question>
        <div style="text-align: right;padding: 10px 0;">
            <a-button :style="{ marginRight: '8px' }" @click="()=>{returnVoteSubjectListvisible = false;}">
                    取消
            </a-button>
        </div>
    </a-modal>
    <div v-show="loading" class="example">
        <a-spin />
    </div>
    <a-modal v-model="modalCheckbox" title="批量修改专家" @ok="handleOkExpertName">
        <a-form-item label="专家名称">
            <a-input
                v-model="modalCheckboxExpertName"
            />
            <p>该名称将作为片头字幕展示，若该视频的专家与课程专家一致则无需填写</p>
        </a-form-item>
    </a-modal>
</div>
</template>

<script>
import draggable from './../../../core/vuedraggable.js';
import addNewActivity from './component/addNewActivity';
import actIcon from './component/actIcon';
import actForm from './component/actForm';
import question from './component/question';

import courseQuestionBank from './../courseQuestionBank/courseQuestionBank';



import EPlayer from '../../../components/ePlayer.js';


const columns = [
  {
    title: '标签',
    dataIndex: 'keyword'
  },
  {
    title: '题干',
    dataIndex: 'qastoreContent'
  },
  {
    title: '题型',
    dataIndex: 'qastoreType',
    scopedSlots: { customRender: 'qastoreType' }
  }
];
const tableData = [];

// groupId: "5c8083a30f0445acb02514ced98c1ae8"
// researchId: "c9bb2e0c90a74e04bd8e983f7ee6b242"

export default {
    components: {
        draggable,
        addNewActivity,
        actIcon,
        actForm,
        courseQuestionBank,
        question
    },
    data(){
        return {
            currentHostname: window.location.hostname,
            modalCheckbox:false,
            ajaxArrCheckbox: [],
            modalCheckboxExpertName: '',
            drag: false,
            loading: false,
            tableData,
            columns,
            pagination:{
                currentPage:1,
                pageSize:10,
                total:10,
                showQuickJumper: true,
                showSizeChanger: true,
                //  showTotal: total => `共有 ${total} 条`, // 显示总数
                pageSizeOptions: ['10', '20', '30', '40', '50']
            },
            selectedRows: [],

            // 添加章节弹窗 相关
            visible: false,
            courseQuestionBankvisible: false,
            confirmLoading: false,
            title: '添加新的章', //弹窗标题
            labelName: '', //input前面的文字
            placeholder: '', //
            addNewText: '', //添加文字
            activityId: '', //添加节活动的章id
            taskId: '', //节id
            isEdit: false, //是否编辑
            questionListList:[], //题目列表
            filename:'',

            // 弹出相关
            addActShow: false, //添加环节弹出框显示隐藏
            actInfoShow: false, //环节详情弹出框显示隐藏
            actInfoShow1: false, //资源库弹出显示隐藏
            actInfoShow2: false, //题库弹出显示隐藏
            actInfoShowtitle: '', //环节title

            //环节actTypeId数据，包含: 环节id、环节名字、
            actTypeIdArr: {
                'ACT002': {
                    type: 'popShowtzyd',
                    name: '拓展阅读',
                    actTypeId: 'ACT002',
                    popShowtzyd: true,
                    saveUrl: this.apis.coursedetail.saveOrUpdateReadLearning,
                    // getUrl: this.apis.coursedetail.getRead,
                    demand: '完成拓展材料的阅读'
                },
                'ACT007': {
                    type: 'popShowspxx',
                    name: '视频学习',
                    actTypeId: 'ACT007',
                    popShowspxx: true,
                    saveUrl: this.apis.coursedetail.saveOrUpdateVideoActAndQa,
                    // getUrl: this.apis.coursedetail.getActRes,
                    demand: [
                        [
                            {
                                key: 'finishTime',
                                value: '',
                                text: '要求观看时长·分钟(填0分钟表示需要观看完整视频)'
                            }
                        ]
                    ]
                },
                'ACT003': {
                    name: '互动研讨',
                    actTypeId: 'ACT003',
                    popShowhttl: true,
                    demand: [
                        [
                            {
                                key: 'mainCount',
                                value: 0,
                                text: '发布主贴，要求发布·张主贴'
                            },
                            {
                                key: 'mainWordCount',
                                value: 0,
                                text: '每贴要求字数为·个字'
                            },
                            {
                                isRadio: true,
                                key: 'isMainNeed',
                                value: true
                            }
                        ],
                        [
                            {
                                key: 'layerCount',
                                value: 0,
                                text: '发布回帖，要求回复他人·张主贴'
                            },
                            {
                                key: 'layerWordCount',
                                value: 0,
                                text: '每贴回复要求字数为·个字'
                            },
                            {
                                isRadio: true,
                                key: 'isLayerNeed',
                                value: true
                            }
                        ]
                    ],
                    saveUrl: this.apis.coursedetail.saveOrUpdateTopic
                    // getUrl: this.apis.coursedetail.getVideo,
                },
                'ACT005': {
                    type: 'popShowwjdc',
                    name: '问卷调查',
                    actTypeId: 'ACT005',
                    popShowwjdc: true,
                    saveUrl: this.apis.coursedetail.saveOrUpdateVote,
                    // getUrl: this.apis.coursedetail.getRead,
                    demand: '完成调查问卷内容并提交'
                },
                'ACT001': {
                    type: 'popShowwlxx',
                    name: '外链学习',
                    actTypeId: 'ACT001',
                    popShowwlxx: true,
                    saveUrl: this.apis.coursedetail.saveOrUpdateReadLearning,
                    // getUrl: this.apis.coursedetail.getRead,
                    demand: '完成学习内容的浏览学习'
                }
            },

            // 打开的环节数据
            actId: '',
            actTypeId: '', //环节id
            actTypeName: '', //环节标签
            actDesc: '', //环节描述
            expertName: '', //专家名称
            actName: '', //环节标题
            isRequired: '',
            thistype: '',
            demand: '', //要求
            needTypeCode: 'N', //是否必修
            addActivityId: '', //章id
            addTaskId: '', // 节id
            resourceArr: [], //资源库列表



            httlDesc: '', //话题描述
            popShowhttl: false,
            popShowtzyd: false,
            popShowspxx: false,
            popShowwjdc: false,
            popShowwlxx: false,

            fileListVideo: [], //弹出层文档文件夹
            defaultFileList:[],
            fileListVideoUrl: '',
            fileListVideo1: [],
            fileListVideoExcelImport: [],
            voteSubjectList: [], //问卷调查列表
            voteImport: '', //问卷调查id
            voteImportDisable: true,
            returnVoteSubjectListvisible: false,
            popShowwlxxUrl: '',
            linkType: '',

            // 视频相关
            videoSrc: '', //浏览器播放地址
            ysUrl: '', //原始地址 用于提交
            fdUrl: '', //流畅
            hdUrl: '', //高清
            ldUrl: '', //标清
            sdUrl: '', //超清
            videoElement: null, //video实体
            videoNowTime: {}, //视频当前地址
            h: '',
            min: '',
            secondTime: '',
            hm: '',
            keyWord: '',
            qastoreContent: '',
            qastoreType: '',
            sortType: '',
            playSubject: 'Y',
            fileData: [],

            // 章节数据
            activityArr: [], //章节数据

            uploader: null, //阿里上传工具
            accId: null, //阿里 OSS直接上传:STS方式 上传4个参数
            accSecret: null, //阿里 OSS直接上传:STS方式 上传4个参数
            expiration: null, //阿里 OSS直接上传:STS方式 上传4个参数
            stsToken: null, //阿里 OSS直接上传:STS方式 上传4个参数
            uploadPercent: 0,

            progressMarkers: [], //视频设置弹题点
            aliYsUrl: '', //阿里上传原始地址
            mediaId: '',
            runId: '',
            player: '',
            playerShow: false,
            playerShowplayerShow: false,
            remark: '',
            summaryTime: 10

        };
    },
    mounted (){
        this.initData();
        this.getUploadSign();
    },
    methods: {
        changecheckbox(index, item, flag){
            console.log(index);
            console.log(item);
            console.log(flag);
            let thisflag = flag.target.checked;
            item.checkbox = thisflag;
            if (index == 1){
                for (let i in item.activityTasks){
                    item.activityTasks[i].checkbox = thisflag;
                    for (let p in item.activityTasks[i].taskActList){
                        item.activityTasks[i].taskActList[p].checkbox = thisflag;
                    }
                }
            } else if (index == 2){
                for (let p in item.taskActList){
                    item.taskActList[p].checkbox = thisflag;
                }
            }
        },
        handleOkExpertName(){
            // console.log();
            console.log(this.modalCheckboxExpertName);
            console.log(this.ajaxArrCheckbox);
            let ajaxData = [];
            for (let i in this.ajaxArrCheckbox){
                ajaxData.push({
                    actId: this.ajaxArrCheckbox[i],
                    expertName: this.modalCheckboxExpertName
                });
            }
            console.log(ajaxData);
            let url = this.apis.courseInfoSetting.updateVideoExpertNameBatch;
            this.http.post(url, ajaxData)
            .then((res)=>{
                if (res.status == 0){
                    this.$message.success('批量设置成功');
                    this.initData();
                    let thisactivityArr = this.activityArr;
                    for (let i in thisactivityArr){
                        thisactivityArr[i].checkbox = false;
                        for (let p in thisactivityArr[i].activityTasks){
                            thisactivityArr[i].activityTasks[p].checkbox = false;
                            for (let o in thisactivityArr[i].activityTasks[p].taskActList){
                                thisactivityArr[i].activityTasks[p].taskActList[o].checkbox = false;
                            }
                        }
                    }
                    this.modalCheckboxExpertName = '';
                    this.modalCheckbox = false;
                }
            }).catch((err)=> {
                this.$message.error(err.message);
            });
        },
        updateVideoExpertNameBatch(){
            this.modalCheckbox = true;
            let thisactivityArr = this.activityArr;
            let ajaxArr = [];
            for (let i in thisactivityArr){
                for (let p in thisactivityArr[i].activityTasks){
                    for (let o in thisactivityArr[i].activityTasks[p].taskActList){
                        if (thisactivityArr[i].activityTasks[p].taskActList[o].checkbox == true){
                            console.log(thisactivityArr[i].activityTasks[p].taskActList[o]);
                            ajaxArr.push(thisactivityArr[i].activityTasks[p].taskActList[o].actId);
                        }
                    }
                }
            }
            this.ajaxArrCheckbox = ajaxArr;
            // console.log(ajaxArr);
        },
        removeFile(){
            this.$message.error('已上传文件不支持删除，可重新上传');
            return false;
        },
        removeFile1(){
            this.summaryTime = 10;
            this.fileListVideoUrl = '';
            this.fileListVideo = [];
            return false;
        },
        autoBuildLesson(){
          let data = {
            'userId': this.appUtils.getUserId(),
            'researchId': this.appUtils.getResearchId(),
            'researchName': this.appUtils.getReaserchInfo().researchName
          };
          let url = this.apis.courseInfoSetting.postAutoBuildLesson;
          this.http.post(url, data)
          .then((res)=>{
            if (res.status == 0){
              this.$message.success('自动建课成功');
              this.initData();
            }
          }).catch((err)=> {
            this.$message.error(err.message);
          });
        },
        initAliPlayer(vid, accId, accSecret, stsToken, domainRegion, authInfo, format, seek){
            this.playerShow = true;
            this.$nextTick(function () {
                this.player = new EPlayer('J_prismPlaye', {
                    vid, accId, accSecret, stsToken, domainRegion, authInfo, format, progressMarkers:this.progressMarkers, seek:seek||0
                });
                this.player.initVideo();
                // if (this.appUtils.getUserId() == '73b3c098c1b311ea8e2a000c2973e385' || this.appUtils.getUserId() == '89086a34c1b311ea8e2a000c2973e385'){
                //     this.player.disableSeek(0);
                // } else {
                //     this.player.disableSeek(10000);
                // }
                this.player.setQuestionList(this.videoQasArr, this.popup, this.updateMongoVideoTime);
                this.player.getCurrentTimePlaying(this.setCurrentTimePlaying);

            });
        },
        setCurrentTimePlaying(time){
            this.videoNowTime = this.formateSeconds(this.player.getCurrentTime());
        },
        getUploadSign(){
            this.http.get(this.apis.upload.getUploadSign).then(res => {
                console.log(res);
                this.accId = res.data.accId;
                this.accSecret = res.data.accSecret;
                this.expiration = res.data.expiration;
                this.stsToken = res.data.stsToken;
                this.initNewUpload();
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        initNewUpload(){
            let that = this;
            this.uploader = new VODUpload({
                // 文件上传失败
                'onUploadFailed': function (uploadInfo, code, message) {
                    that.log('onUploadFailed: file:' + uploadInfo.file.name + ',code:' + code + ', message:' + message);
                },
                // 文件上传完成
                'onUploadSucceed': function (uploadInfo) {
                    that.log('onUploadSucceed: ' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object);
                    // uploadInfo.file.name
                    console.log(uploadInfo,'*********************-------------------');
                    // let ajaxData = {};
                    that.loading = false;
                    // ajaxData.fileUrl = '/' + uploadInfo.object;
                    // that.http.get(that.apis.coursedetail.execVideoResource, ajaxData).then(res => {
                    //     console.log(res);
                    //     // this.http.get(this.apis.coursedetail.getMediaIdByOssUrl, {
                    //     //     ossUrl: getMediaIdByOssUrlUrl
                    //     // }).then(res => {
                    //     //     console.log(res);
                    //     //     this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+res.data.MediaId, {
                    //     //     }).then(res => {
                    //     //         console.log(res);
                    //     //     }).catch(err => {
                    //     //         this.$message.error('获取媒体id失败');
                    //     //     })
                    //     // }).catch(err => {
                    //     //     this.$message.error('获取媒体id失败');
                    //     // })
                    //     // let resData = res.data;
                    //     // that.getJobDone(resData);
                    // }).catch(err => {
                    //     that.$message.error('转码失败');
                    // });
                    that.$confirm({
                        title: '正在转码',
                        content: '转码耗时较长，是否继续等待',
                        onOk() {
                            that.playerShow = false;
                            that.playerShowplayerShow = true;
                            // that.$nextTick(function () {
                            //     that.initAliPlayer('', '', '', '', '', '', '', 0);
                            // });
                            that.aliYsUrl = (uploadInfo.endpoint.replace('//','//' + uploadInfo.bucket + '.') + '/' + uploadInfo.object).replace('https','http');
                            console.log(that.aliYsUrl);
                            that.http.get(that.apis.coursedetail.getMediaIdByOssUrl, {
                                ossUrl: that.aliYsUrl
                            }).then(res => {
                                console.log(res);
                                that.runId = res.data.RunIdList.RunId[0];
                                that.mediaId = res.data.MediaId;
                                // console.log(that.runId);
                                that.getMediaWorkflowExecutionByRunId(res.data.RunIdList.RunId[0]);
                                that.playerShow = false;
                                that.playerShowplayerShow = true;
                                // that.$nextTick(function () {
                                //     that.initAliPlayer(res.data.vid, res.data.accId, res.data.accSecret, res.data.stsToken, res.data.domainRegion, res.data.authInfo, res.data.format, 0);
                                // });
                            }).catch(err => {
                                that.$message.error('获取媒体id失败');
                            });
                        },
                        onCancel() {
                            that.aliYsUrl = (uploadInfo.endpoint.replace('//','//' + uploadInfo.bucket + '.') + '/' + uploadInfo.object).replace('https','http');
                            that.http.get(that.apis.coursedetail.getMediaIdByOssUrl, {
                                ossUrl: that.aliYsUrl
                            }).then(res => {
                                console.log(res);
                                that.runId = res.data.RunIdList.RunId[0];
                                console.log(that.runId);
                                that.http.get(that.apis.coursedetail.getMediaWorkflowExecutionByRunId + '/' + res.data.RunIdList.RunId[0], {}).then(res => {
                                    that.mediaId = res.data.MediaId;
                                    // that.runId = res.data.RunIdList.RunId[0];
                                    that.submitActInfo3();
                                }).catch(err => {
                                    console.log(err);
                                    that.$message.error('转码失败');
                                });
                            }).catch(err => {
                                console.log(err);
                                that.$message.error('获取媒体id失败');
                            });
                        }
                    });
                },
                // 文件上传进度
                'onUploadProgress': function (uploadInfo, totalSize, uploadedSize) {
                    // console.log(uploadInfo);
                    // console.log(totalSize);
                    // console.log(uploadedSize);
                    // that.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(uploadedSize * 100 / totalSize) + "%");
                    that.uploadPercent = Math.ceil(uploadedSize * 100 / totalSize);
                },
                // STS临时账号会过期，过期时触发函数
                'onUploadTokenExpired': function () {
                    that.log('onUploadTokenExpired');
                    this.http.get(this.apis.upload.getUploadSign).then(res => {
                        console.log(res);
                        this.accId = res.data.accId;
                        this.accSecret = res.data.accSecret;
                        this.expiration = res.data.expiration;
                        this.stsToken = res.data.stsToken;
                        uploader.resumeUploadWithToken(res.data.accId, res.data.accSecret, res.data.stsToken, res.data.expiration);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                    // if (isVodMode()) {
                    //     // 实现时，从新获取UploadAuth
                    //     // uploader.resumeUploadWithAuth(uploadAuth);
                    // } else if (isSTSMode()) {
                    //     // 实现时，从新获取STS临时账号用于恢复上传
                    //     // uploader.resumeUploadWithToken(accessKeyId, accessKeySecret, secretToken, expireTime);
                    // }
                },
                // 开始上传
                'onUploadstarted': function (uploadInfo) {
                    // if (isVodMode()) {
                    //     var uploadAuth = document.getElementById("uploadAuth").value;
                    //     var uploadAddress = document.getElementById("uploadAddress").value;
                    //     this.uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress);
                    // }
                    that.log('onUploadStarted:' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:' + uploadInfo.bucket + ', object:' + uploadInfo.object);
                }
            });


            this.uploader.init(this.accId, this.accSecret, this.stsToken, this.expiration);
            console.log('完成');
        },
        getMediaWorkflowExecutionByRunId(resData){
            this.http.get(this.apis.coursedetail.getMediaWorkflowExecutionByRunId + '/' + resData, {}).then(res => {
                console.log(res);
                if (res.data.State == 'Running'){
                    this.$message.success('正在全力转码中');
                    let that = this;
                    let time = setTimeout(function (){
                        if (that.actInfoShow == true){
                            that.getMediaWorkflowExecutionByRunId(resData);
                        }
                    },5000);
                } else if (res.data.State == 'Completed'){
                    this.mediaId = res.data.MediaId;
                    this.runId = res.data.RunId;
                    this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+res.data.MediaId, {

                    }).then(res => {
                        if (res.data.vid){
                            this.playerShow = false;
                            this.playerShowplayerShow = false;
                            this.$nextTick(function () {
                                this.initAliPlayer(res.data.vid, res.data.accId, res.data.accSecret, res.data.stsToken, res.data.domainRegion, res.data.authInfo, res.data.format, 0);
                            });
                        }
                    }).catch(err => {

                        this.$message.error('获取媒体id失败');
                    });
                    this.ysUrl = resData.ysUrl;
                    // this.$message.success('转码成功');
                }
            }).catch(err => {
                console.log(err);
                this.$message.error('转码失败');
            });
        },
        //提交表单 只提交视频
        submitActInfo3(){
            let data = {};
            // 基础
            data.videoYsUrl = this.aliYsUrl;
            data.mediaId = this.mediaId;
            data.runId = this.runId;

            data.actId = this.actId || '';
            if (!data.actId){
                data.taskId = this.taskId;
                data.userId = this.appUtils.getUserId();
                data.activityId = this.addActivityId;
            }
            data.actTypeId = this.actTypeId;
            data.appId = this.appUtils.getAppId();
            // 如果是节下面的
            if (this.addTaskId){
                data.taskId = this.addTaskId;
            }


            // 公用字段
            data.actTypeName = this.$refs.actInfo.thisActTypeName || '';
            data.actName = this.$refs.actInfo.thisActName || '';
            data.actDesc = this.$refs.actInfo.thisActDesc || '';
            data.expertName = this.$refs.actInfo.thisExpertName || '';
            data.isRequired = this.$refs.actInfo.thisisRequired || 'N';


            data.time = parseInt(this.player.getDuration());
            data.remark = this.remark;
            data.researchId = this.appUtils.getResearchId();


            this.http.post(this.apis.coursedetail.saveOrUpdateVideoActAndQa, data).then(res => {
                this.initData();
                this.actInfoShow = false;
                this.playerShow = false;
                this.$message.success('保存成功');
                this.onClose();
            }).catch(err => {
                this.$message.error(err.message);
                this.onClose();
            });
        },
        //提交表单 提交第二层
        submitActInfo(){
            this.loading = true;
            let data = {};
            // 基础
            data.actId = this.actId || '';
            // data.taskId = this.taskId;
            if (!data.actId){
                data.userId = this.appUtils.getUserId();
                data.activityId = this.addActivityId;
            }
            data.appId = this.appUtils.getAppId();

            // 公用字段
            data.actTypeName = this.$refs.actInfo.thisActTypeName;
            if (!data.actTypeName){
                this.$message.error('请填写必填字段');
                this.loading = false;
                return false;
            }
            data.actTypeId = this.actTypeId;
            data.actName = this.$refs.actInfo.thisActName;
            if (!data.actName){
                this.$message.error('请填写必填字段');
                this.loading = false;
                return false;
            }
            data.actDesc = this.$refs.actInfo.thisActDesc;
            data.expertName = this.$refs.actInfo.thisExpertName;
            data.isRequired = this.$refs.actInfo.thisisRequired;


            // 次公用字段
            console.log(this.demand);
            var isMainNeed = false;
            var isLayerNeed = false;
            if ((typeof this.demand) != 'string'){
                for (let i in this.demand){
                    for (let p in this.demand[i]){
                        if (this.demand[i][p].isRadio){
                            if (this.demand[i][p].value === true || this.demand[i][p].value === ''){
                                data[this.demand[i][p].key] = 'Y';
                                console.log(this.demand[i][0].value);
                                if (this.demand[i][p].key == 'isMainNeed'){
                                    if (this.demand[i][0].value <= 0 || this.demand[i][1].value <= 0){
                                        this.$message.error('勾选选项后，发帖数和字数需均大于0');
                                        this.loading = false;
                                        return false;
                                    }
                                }
                                if (this.demand[i][p].key == 'isLayerNeed'){
                                    if (this.demand[i][0].value <= 0 || this.demand[i][1].value <= 0){
                                        this.$message.error('勾选选项后，发帖数和字数需均大于0');
                                        this.loading = false;
                                        return false;
                                    }
                                }
                            } else {
                                data[this.demand[i][p].key] = 'N';
                            }
                        } else {
                            if (
                                this.demand[i][p].key == 'mainCount' ||
                                this.demand[i][p].key == 'mainWordCount' ||
                                this.demand[i][p].key == 'layerCount' ||
                                this.demand[i][p].key == 'layerWordCount'
                            ){
                                data[this.demand[i][p].key] = this.demand[i][p].value || 0;
                            } else {
                                data[this.demand[i][p].key] = this.demand[i][p].value;
                            }

                            // if (!this.demand[i][p].value || this.demand[i][p].value < 0){
                            //     this.$message.error('请填写必填字段');
                            //     this.loading = false;
                            //     return false;
                            // }
                        }
                    }
                }
            }



            // // 特殊化
            // // 签到
            // if (this.actTypeIdArr[this.actTypeId].popShowTime){
            //     data.startDt = this.signTime[0].format('YYYY-MM-DD HH:mm:ss');
            //     data.endDt = this.signTime[1].format('YYYY-MM-DD HH:mm:ss');
            // }

            // 互动研讨
            if (this.actTypeIdArr[this.actTypeId].popShowhttl){
                if (data.isLayerNeed == 'N' && data.isMainNeed == 'N'){
                    this.$message.error('考核要求必须勾选一个或两个');
                    this.loading = false;
                    return false;
                }
            }

            // 阅读
            if (this.actTypeIdArr[this.actTypeId].popShowtzyd){
                if (!this.fileListVideoUrl){
                    this.$message.error('请填写必填字段');
                    this.loading = false;
                    return false;
                }
                data.url = this.fileListVideoUrl;
                console.log(this.fileListVideo);
                console.log(this.fileListVideo[0]);
                if (this.fileListVideo.length == 0){
                    data.fileName = this.filename;
                } else {
                    if (this.fileListVideo[0].name){
                        data.fileName = this.fileListVideo[0].name;
                    } else {
                        if (this.fileListVideo[0].url){
                            data.fileName = this.filename;
                        } else {
                            data.fileName = this.fileListVideo[0].response.data.fileName;
                        }
                    }
                }
            }

            // 文档
            if (this.actTypeIdArr[this.actTypeId].popShowhttl){
                data.fileContent = this.httlDesc;
                if (!data.fileContent){
                    this.$message.error('请填写必填字段');
                    this.loading = false;
                    return false;
                }
            }

            // 外链
            if (this.actTypeIdArr[this.actTypeId].popShowwlxx){
                data.url = this.popShowwlxxUrl;
                if (!data.url){
                    this.$message.error('请填写必填字段');
                    this.loading = false;
                    return false;
                }
                // var reg=/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
                var reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
                if (!reg.test((data.url).split('?')[0])){
                    this.$message.error('请填正确的外链地址，需包括连接头部，如http://');
                    this.loading = false;
                    return false;
                }
                data.linkType = this.linkType;
                if (!data.linkType){
                    this.$message.error('请填写必填字段');
                    this.loading = false;
                    return false;
                }
            }


            // 问卷
            if (this.actTypeIdArr[this.actTypeId].popShowwjdc){
                data.voteSubjectList = this.voteSubjectList;
                if (this.voteSubjectList.length == 0){
                    this.$message.error('上传问卷内容');
                    this.loading = false;
                    return false;
                }
            }

            // 题目
            if (this.actTypeIdArr[this.actTypeId].popShowspxx){
                // data.finishTime
                if (data.finishTime){
                    data.finishTime = data.finishTime * 60;
                } else {
                    let time = parseInt(this.player.getDuration());
                    if (time < 600 && time > 80){
                        data.finishTime = time - 60;
                    } else if (time >= 600){
                        data.finishTime = time - 120;
                    } else {
                        data.finishTime = time;
                    }
                }

                data.summaryFilePath = this.fileListVideoUrl;
                if (this.fileListVideo.length == 0){
                    data.summaryFileName = this.filename;
                } else {
                    if (this.summaryTime == 0 || this.summaryTime == ''){
                        this.$message.error('请填写视频提要需要观看秒数');
                        this.loading = false;
                        return false;
                    }
                    data.summaryTime = this.summaryTime;
                    if (this.fileListVideo[0].name){
                        data.summaryFileName = this.fileListVideo[0].name;
                    } else {
                        if (this.fileListVideo[0].url){
                            data.summaryFileName = this.filename;
                        } else {
                            data.summaryFileName = this.fileListVideo[0].response.data.fileName;
                        }
                    }
                }
                if (
                    data.summaryFileName.toLocaleLowerCase().indexOf('jpg') > 0 ||
                    data.summaryFileName.toLocaleLowerCase().indexOf('png') > 0
                ){
                    data.summaryFileType = 'images';
                } else {
                    data.summaryFileType = 'file';
                }
                if (!data.summaryFileName){
                    data.summaryTime = 0;
                }
                data.playSubject = this.playSubject;
                data.videoQas = [];
                for (let i in this.questionListList){
                    let newObj = {};
                    newObj.qastoreId = this.questionListList[i].qastoreId;
                    newObj.qaTime = `${this.questionListList[i].h}:${this.questionListList[i].min}:${this.questionListList[i].secondTime}.${this.questionListList[i].hm}`;
                    // h = this.h;
                    // this.selectedRows[i].min = this.min;
                    // this.selectedRows[i].secondTime = this.secondTime;
                    // this.selectedRows[i].hm
                    data.videoQas.push(newObj);

                }
                data.mediaId = this.mediaId;
                data.runId = this.runId;
                data.time = parseInt(this.player.getDuration());
                data.remark = this.remark;
                data.researchId = this.appUtils.getResearchId();
                // this.videoSrc = resData.ysUrl;
                // this.fdUrl = resData.fdUrl;
                // this.hdUrl = resData.hdUrl;
                // this.ldUrl = resData.ldUrl;
                // this.sdUrl = resData.sdUrl;
                if (this.aliYsUrl){
                    data.videoYsUrl = this.aliYsUrl;
                } else {
                    this.$message.error('请选择视频');
                    this.loading = false;
                    return false;
                }
                // if (this.fdUrl){
                //     data.videolcUrl = this.fdUrl;
                // } else {
                //     this.$message.error('请选择视频');
                //     return false;
                // }
                // if (this.ldUrl){
                //     data.videoUrl = this.ldUrl;
                // } else {
                //     this.$message.error('请选择视频');
                //     return false;
                // }
                // if (this.hdUrl){
                //     data.videoHdUrl = this.hdUrl;
                // } else {
                //     this.$message.error('请选择视频');
                //     return false;
                // }
                // if (this.sdUrl){
                //     data.videoCqUrl = this.sdUrl;
                // } else {
                //     this.$message.error('请选择视频');
                //     return false;
                // }
                // "videoYsUrl":"原始资源地址",
                // "videolcUrl":"流畅资源地址",
                // "videoUrl":"标清资源地址",
                // "videoHdUrl":"高清资源地址",
                // "videoCqUrl":"超清资源地址",
            }

            // 如果是节下面的
            if (this.addTaskId){
                data.taskId = this.addTaskId;
            }

            console.log(data);

            this.http.post(this.actTypeIdArr[data.actTypeId].saveUrl, data).then(res => {
                this.initData();
                this.actInfoShow = false;
                this.$message.success('保存成功');
                this.onClose();
            }).catch(err => {
                this.$message.error(err.message);
                this.onClose();
            });
        },
        submitActInfo2(){
            // console.log(this.selectedRows);
            if (this.selectedRows){
                if (this.selectedRows.length > 0){
                    this.actInfoShow2 = false;
                    for (let i in this.selectedRows){
                        this.selectedRows[i].time = this.videoNowTime;
                        this.selectedRows[i].h = this.h;
                        this.selectedRows[i].min = this.min;
                        this.selectedRows[i].secondTime = this.secondTime;
                        this.selectedRows[i].hm = this.hm;
                        this.questionListList.push(this.selectedRows[i]);
                    }
                    console.log(this.questionListList);
                    // this.questionListList = this.selectedRows;
                } else {
                    this.$message.error('请选择题目');
                }
            } else {
                this.$message.error('请选择题目');
            }
        },
        downloadWJDC(){
            window.open(this.apis.coursedetail.downloadTemplate, '_blank');
        },
        delQuestion(index){
            this.questionListList.splice(index,1);
        },
        delQuestionAll(){
            this.questionListList = [];
            this.chooseQuestion();
        },
        // 关闭抽屉
        onClose(){
            this.actInfoShow = false;
            this.playerShow = false;
            this.loading = false;
            this.fileListVideo = [];
            this.videoNowTime = {};
            // window.document.body.style.overflowY = 'auto';
        },
        // 关闭抽屉1
        onClose1(){
            this.actInfoShow1 = false;
            // window.document.body.style.overflowY = 'auto';
        },
        // 关闭抽屉1
        onClose2(){
            this.actInfoShow2 = false;
            // window.document.body.style.overflowY = 'auto';
        },
        // 关闭第一层
        hideModal() {
            this.addActShow = false;
        },
        // 打开第二层 编辑
        editAct1(item, pitem){
            console.log(item);
            console.log(pitem);

            this.playerShow = false;
            this.initAliPlayer('', '', '', '', '', '', '', 0);
            this.addActShow = false;
            this.actInfoShow = true;
            this.http.get(this.apis.coursedetail.getActById, {
                actId: item.actId
            }).then(res => {
                console.log(res,'/////////*******************************');
                let resData = res.data;
                if (this.actTypeIdArr[resData.actTypeId].popShowhttl){
                    this.popShowhttl = true;
                    this.demand = this.actTypeIdArr[resData.actTypeId].demand || '';
                    for (let i in this.actTypeIdArr[resData.actTypeId].demand){
                        for (let p in this.actTypeIdArr[resData.actTypeId].demand[i]){
                            console.log(this.actTypeIdArr[resData.actTypeId].demand[i][p].key);
                            if (this.actTypeIdArr[resData.actTypeId].demand[i][p].key != 'isMainNeed' && this.actTypeIdArr[resData.actTypeId].demand[i][p].key != 'isLayerNeed'){
                                this.actTypeIdArr[resData.actTypeId].demand[i][p].value = resData[this.actTypeIdArr[resData.actTypeId].demand[i][p].key] || 0;
                            } else {
                                this.actTypeIdArr[resData.actTypeId].demand[i][p].value = ((resData[this.actTypeIdArr[resData.actTypeId].demand[i][p].key] == 'Y') ? true : false);
                            }
                        }
                    }
                    console.log(this.actTypeIdArr);
                } else {
                    this.popShowhttl = false;
                }

                if (this.actTypeIdArr[resData.actTypeId].popShowtzyd){
                    this.popShowtzyd = true;
                    this.fileListVideoUrl = resData.url;
                    this.demand = this.actTypeIdArr[resData.actTypeId].demand;
                    this.fileListVideo = [{
                        uid: '1',
                        name: resData.fileName,
                        status: 'done',
                        url: resData.url
                    }];
                    this.filename = resData.fileName || resData.actName;
                } else {
                    this.popShowtzyd = false;
                }


                if (this.actTypeIdArr[resData.actTypeId].popShowwlxx){
                    this.popShowwlxx = true;

                    this.popShowwlxxUrl = resData.url;
                    this.linkType = resData.linkType;
                } else {
                    this.popShowwlxx = false;
                }

                if (this.actTypeIdArr[resData.actTypeId].popShowwjdc){
                    this.popShowwjdc = true;
                    this.demand = this.actTypeIdArr[resData.actTypeId].demand;
                    this.voteSubjectList = resData.voteSubjectList;
                    this.voteImport = '';
                    if (resData.voteSubjectList.length == 0){
                        this.voteImportDisable = true;
                    } else {
                        this.voteImportDisable = false;
                    }
                } else {
                    this.popShowwjdc = false;
                }



                if (this.actTypeIdArr[resData.actTypeId].popShowspxx){
                    this.fileListVideoUrl = '';
                    this.fileListVideo = [];
                    this.filename = '';
                    resData.finishTime = parseInt(resData.finishTime/60);
                    this.popShowspxx = true;
                    this.demand = this.actTypeIdArr[resData.actTypeId].demand || '';
                    for (let i in this.actTypeIdArr[resData.actTypeId].demand){
                        for (let p in this.actTypeIdArr[resData.actTypeId].demand[i]){
                            this.actTypeIdArr[resData.actTypeId].demand[i][p].value = resData[this.actTypeIdArr[resData.actTypeId].demand[i][p].key] || 0;
                        }
                    }
                    if (resData.summaryFilePath){
                        this.fileListVideoUrl = resData.summaryFilePath || '';
                        this.fileListVideo = [{
                            uid: '1',
                            name: resData.summaryFileName || '无',
                            status: 'done',
                            url: resData.summaryFilePath || '无'
                        }];
                    } else {
                        this.fileListVideo = [];
                    }
                    this.summaryTime = resData.summaryTime;
                    this.videoSrc = resData.videolcUrl;
                    this.sdUrl = resData.videoCqUrl;
                    this.hdUrl = resData.videoHdUrl;
                    this.ldUrl = resData.videoUrl;
                    this.ysUrl = resData.videoYsUrl;
                    this.fdUrl = resData.videolcUrl;
                    this.uploadPercent = 0;
                    this.playSubject = resData.playSubject;
                    for (let i in resData.videoQas){
                        resData.videoQas[i].h = resData.videoQas[i].qaTime.split(':')[0];
                        resData.videoQas[i].min = resData.videoQas[i].qaTime.split(':')[1];
                        resData.videoQas[i].secondTime = (resData.videoQas[i].qaTime.split(':')[2]).split('.')[0];
                        resData.videoQas[i].hm = resData.videoQas[i].qaTime.split('.')[1];
                    }
                    this.questionListList = resData.videoQas;
                    this.aliYsUrl = resData.videoYsUrl;
                    this.runId = resData.runId;
                    console.log(resData);

                    if (resData.mediaId){
                        this.mediaId = resData.mediaId;
                        if (resData.MediaId && resData.PublishState != 'Published'){
                            if (resData.runId){
                                this.getMediaWorkflowExecutionByRunId(resData.runId);
                            } else {
                                this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+resData.mediaId, {
                                }).then(res => {
                                    console.log(res);
                                    if (res.data.vid){
                                        this.playerShow = false;
                                        this.$nextTick(function () {
                                            this.initAliPlayer(res.data.vid, res.data.accId, res.data.accSecret, res.data.stsToken, res.data.domainRegion, res.data.authInfo, res.data.format, 0);
                                        });
                                    }
                                }).catch(err => {
                                    this.$message.error('获取媒体id失败');
                                });
                            }
                        } else {
                            this.$nextTick(function () {
                                this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+resData.mediaId, {
                                }).then(res => {
                                    console.log(res);
                                    if (res.data.vid){
                                        this.playerShow = false;
                                        this.$nextTick(function () {
                                            this.initAliPlayer(res.data.vid, res.data.accId, res.data.accSecret, res.data.stsToken, res.data.domainRegion, res.data.authInfo, res.data.format, 0);
                                        });
                                    }
                                }).catch(err => {
                                    this.$message.error('获取媒体id失败');
                                });
                            });
                        }


                    } else {
                      this.http.get(this.apis.coursedetail.getMediaIdByOssUrl, {
                          ossUrl: resData.videoYsUrl
                      }).then(res => {
                          console.log(res);
                          let ThisrunId = res.data.RunIdList.RunId[0];
                          this.runId = res.data.RunIdList.RunId[0];
                          console.log(this.runId);
                          this.http.get(this.apis.coursedetail.getMediaWorkflowExecutionByRunId + '/' + res.data.RunIdList.RunId[0], {}).then(res => {
                              console.log(res);
                              this.mediaId = res.data.MediaId;
                              // this.runId = res.data.RunIdList.RunId[0];
                              if (res.data.State == 'Running'){
                                  this.playerShow = false;
                                  this.playerShowplayerShow = true;
                                  let that = this;
                                  let time = setTimeout(function (){
                                      that.getMediaWorkflowExecutionByRunId(ThisrunId);
                                  },5000);
                              } else if (res.data.State == 'Completed'){
                                  this.$nextTick(function () {
                                      this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+resData.mediaId, {
                                      }).then(res => {
                                          console.log(res);
                                          if (res.data.vid){
                                              this.playerShow = false;
                                              this.$nextTick(function () {
                                                  this.initAliPlayer(res.data.vid, res.data.accId, res.data.accSecret, res.data.stsToken, res.data.domainRegion, res.data.authInfo, res.data.format, 0);
                                              });
                                          }
                                      }).catch(err => {
                                          this.$message.error('获取媒体id失败');
                                      });
                                  });
                              }
                          }).catch(err => {
                              console.log(err);
                          });
                      }).catch(err => {
                          console.log(err);
                          this.$message.error('获取媒体id失败');
                      });
                    }

                } else {
                    this.popShowspxx = false;
                }

                console.log(this.demand);

                this.actInfoShowtitle = this.actTypeIdArr[resData.actTypeId].name;
                this.actTypeId = resData.actTypeId;
                this.actName = resData.actName;
                this.isRequired = resData.isRequired;
                this.actTypeName = resData.actTypeName;
                this.thistype = this.actTypeIdArr[resData.actTypeId].type;
                this.actDesc = resData.actDesc;
                this.expertName = resData.expertName;
                this.remark = resData.remark;
                this.httlDesc = resData.fileContent;
                this.actId = resData.actId;
                this.taskId = resData.taskId;
                this.addTaskId = '';
                // this.addActivityId = pitem.activityId;
                this.$nextTick(function () {
                    this.$refs.actInfo.initInfo();
                    let time = setTimeout(function (){
                        window.document.body.style.overflowY = 'hidden';
                    },500);
                });
            }).catch(err => {
                console.log(err);
                this.$message.error(err.message);
            });

        },
        // 打开第二层 添加
        showActInfo(actTypeId){
            this.addActShow = false;
            this.actInfoShow = true;
            this.actId = '';
            this.demand = this.actTypeIdArr[actTypeId].demand || '';


            if (this.actTypeIdArr[actTypeId].popShowhttl){
                this.popShowhttl = true;
                this.demand = this.actTypeIdArr[actTypeId].demand || '';
                for (let i in this.actTypeIdArr[actTypeId].demand){
                    for (let p in this.actTypeIdArr[actTypeId].demand[i]){
                        this.actTypeIdArr[actTypeId].demand[i][p].value = '';
                    }
                }
            } else {
                this.popShowhttl = false;
            }
            // this.resetActInfo();

            if (this.actTypeIdArr[actTypeId].popShowtzyd){
                this.popShowtzyd = true;
                this.fileListVideoUrl = '';
                this.fileListVideo = [];
                this.filename = '';
            } else {
                this.popShowtzyd = false;
            }

            console.log(actTypeId);
            console.log(this.actTypeIdArr[actTypeId]);
            if (this.actTypeIdArr[actTypeId].popShowwlxx){
                this.popShowwlxx = true;
                this.popShowwlxxUrl = '';
                this.linkType = '';
                // this.fileListVideoUrl = '';
                // this.fileListVideo = [];
                // this.filename = '';
            } else {
                this.popShowwlxx = false;
            }

            if (this.actTypeIdArr[actTypeId].popShowspxx){
                this.popShowspxx = true;
                this.fileListVideo1 = [];
                this.fileListVideoUrl = '';
                this.fileListVideo = [];
                this.demand = this.actTypeIdArr[actTypeId].demand || '';
                for (let i in this.actTypeIdArr[actTypeId].demand){
                    console.log(this.actTypeIdArr[actTypeId].demand[i]);
                    for (let p in this.actTypeIdArr[actTypeId].demand[i]){
                        this.actTypeIdArr[actTypeId].demand[i][p].value = '';
                    }
                }
                this.videoSrc = '';
                this.sdUrl = '';
                this.hdUrl = '';
                this.ldUrl = '';
                this.ysUrl = '';
                this.fdUrl = '';
                this.playSubject = 'Y';
                this.questionListList = [];
                this.aliYsUrl = '';
                this.mediaId = '';
                this.runId = '';
                this.uploadPercent = 0;
                this.playerShow = false;
                this.$nextTick(function () {
                    this.initAliPlayer();
                });
            } else {
                this.popShowspxx = false;
            }

            if (this.actTypeIdArr[actTypeId].popShowwjdc){
                this.popShowwjdc = true;
                this.voteSubjectList = [];
                this.voteImport = '';
                this.voteImportDisable = true;
            } else {
                this.popShowwjdc = false;
            }



            this.actInfoShowtitle = this.actTypeIdArr[actTypeId].name;
            this.actTypeId = actTypeId;
            this.actTypeName = this.actTypeIdArr[actTypeId].name;
            this.thistype = this.actTypeIdArr[actTypeId].type;



            this.actName = '';
            this.actDesc = '';
            this.expertName = '';
            this.httlDesc = '';
            this.isRequired = '';



            this.$nextTick(function () {
                this.$refs.actInfo.initInfo();
                let time = setTimeout(function (){
                    window.document.body.style.overflowY = 'hidden';
                },500);
            });
        },
        // 第二层的number改变触发
        inputChange(e ,item){
            // console.log(item);
            // console.log(e.target.value);
            if (e.target.value < 0){
                item.value = 0;
            }
            e.target.value = parseInt(e);
        },
        returnVoteSubjectListhandleOk(){
            this.returnVoteSubjectListvisible = false;
        },
        showVoteSubjectList(){
            console.log(this.voteSubjectList);
            if (this.voteSubjectList.length > 0){
                this.returnVoteSubjectListvisible = true;
            }
        },
        // 打开第一层
        addTask(activityId, taskId){
            this.addActivityId = activityId;
            this.addTaskId = taskId || '';
            // console.log("添加");
            this.addActShow = true;
        },
        sort(){
            this.list = this.list.sort((a, b) => a.order - b.order);
        },
        addAct(activityId){
            if (activityId){
                this.title = '添加新的小节';
                this.labelName = '小节名称';
                this.placeholder = '小节名称';
                this.addNewText = '添加新的小节';
                this.isEdit = false;
                this.activityId = activityId;
                this.taskId = '';
            } else {
                this.title = '添加新的章';
                this.labelName = '章名称';
                this.placeholder = '章名称';
                this.addNewText = '添加新的章';
                this.isEdit = false;
                this.activityId = '';
                this.taskId = '';
            }
            this.visible = true;
            this.$nextTick(function (){
                this.$refs.addNewAct.initData();
            });
        },
        editAct(item){
            console.log(item);
            if (item.taskId){
                this.title = '修改小节',
                this.labelName = '小节名称';
                this.placeholder = item.taskName;
                this.addNewText = '';
                this.isEdit = true;
                this.taskId = item.taskId;
            } else {
                this.title = '修改章',
                this.labelName = '章名称';
                this.placeholder = item.activityName;
                this.addNewText = '';
                this.isEdit = true;
                this.activityId = item.activityId;
                this.taskId = '';
            }
            this.visible = true;
            this.$nextTick(function (){
                this.$refs.addNewAct.initData();
            });
        },
        delAct(item){
            let that = this;
            this.$confirm({
                title: '敏感操作?',
                content: '是否确认删除此章',
                onOk() {
                    that.http.delete(that.apis.coursedetail.deleteActivityInfoById + '/' + item.activityId, {}).then(res => {
                        console.log(res);
                        that.$message.success('删除成功');
                        that.initData();
                    }).catch(err => {
                        that.$message.error(err.message);
                    });
                },
                onCancel() {}
            });
        },
        delAct1(item){
            let that = this;
            this.$confirm({
                title: '敏感操作?',
                content: '是否确认删除此节',
                onOk() {
                    that.http.put(that.apis.coursedetail.taskDelete + '/' + item.taskId, {}).then(res => {
                        console.log(res);
                        that.$message.success('删除成功');
                        that.initData();
                    }).catch(err => {
                        that.$message.error(err.message);
                    });
                },
                onCancel() {}
            });
        },
        delAct3(item, item1){
            console.log(item);
            console.log(item1);
            let that = this;
            this.$confirm({
                title: '敏感操作?',
                content: '是否确认删除此活动',
                onOk() {
                    that.http.delete(that.apis.coursedetail.deleteActById + '/' + item.actId+'?researchId='+that.appUtils.getResearchId(), {}).then(res => {
                        console.log(res);
                        // that.http.put(that.apis.coursedetail.taskDelete + '/' + item1.taskId, {}).then(res => {
                            console.log(res);
                            that.$message.success('删除成功');
                            that.initData();
                        // }).catch(err => {
                        //     that.$message.error('请求失败');
                        // })
                    }).catch(err => {
                        that.$message.error(err.message);
                    });
                },
                onCancel() {}
            });
        },
        delAct2(item){
            console.log(item);
            let that = this;
            this.$confirm({
                title: '敏感操作?',
                content: '是否确认删除此活动',
                onOk() {
                    that.http.delete(that.apis.coursedetail.deleteActById + '/' + item.actId+'?researchId='+that.appUtils.getResearchId(), {}).then(res => {
                        console.log(res);
                        that.$message.success('删除成功');
                        that.initData();
                    }).catch(err => {
                        that.$message.error(err.message);
                    });
                },
                onCancel() {}
            });
        },

        handleOk(e) {
            this.confirmLoading = true;
            if (this.isEdit){
                // 编辑
                if (this.taskId){
                    // 编辑节
                    this.editTaskInfo();
                } else {
                    // 编辑章
                    this.editActInfo();
                }
            } else {
                // 新增
                if (this.activityId){
                    // 新增节
                    this.addNewTask();
                } else {
                    // 新增章
                    this.addNewAct();
                }
            }
        },
        editTaskInfo(){
            // 编辑节
            if (this.$refs.addNewAct.inputData[0].value == ''){
                this.$message.error('必填项不能为空');
                this.confirmLoading = false;
                return false;
            }
            let newObj = {};
            newObj.taskName = this.$refs.addNewAct.inputData[0].value;
            newObj.taskId = this.taskId;
            this.http.post(this.apis.coursedetail.updateTaskInfo, newObj).then(res => {
                console.log(res);
                this.$message.success('修改成功');
                this.visible = false;
                this.confirmLoading = false;
                this.initData();
            }).catch(err => {
                this.$message.error(err.message);
                this.confirmLoading = false;
            });
        },
        editActInfo(){
            // 编辑章
            if (this.$refs.addNewAct.inputData[0].value == ''){
                this.$message.error('必填项不能为空');
                this.confirmLoading = false;
                return false;
            }
            let newObj = {};
            newObj.activityName = this.$refs.addNewAct.inputData[0].value;
            newObj.activityId = this.activityId;
            newObj.updatedBy = this.appUtils.getUserId();
            this.http.post(this.apis.coursedetail.insertOrUpdateActivityInfo, newObj).then(res => {
                console.log(res);
                this.$message.success('修改成功');
                this.visible = false;
                this.confirmLoading = false;
                this.initData();
            }).catch(err => {
                this.$message.error(err.message);
                this.confirmLoading = false;
            });
        },
        addNewTask(){
            // 新增节
            let ajaxData = [];
            for (let i in this.$refs.addNewAct.inputData){
                if (this.$refs.addNewAct.inputData[i].value == ''){
                    this.$message.error('必填项不能为空');
                    this.confirmLoading = false;
                    return false;
                }
                let newObj = {};
                newObj.taskName = this.$refs.addNewAct.inputData[i].value;
                newObj.activityId = this.activityId;
                ajaxData.push(newObj);
            }

            this.http.post(this.apis.coursedetail.batchInsertActivityTask, ajaxData).then(res => {
                console.log(res);
                this.$message.success('添加成功');
                this.visible = false;
                this.confirmLoading = false;
                this.initData();
            }).catch(err => {
                this.$message.error(err.message);
                this.confirmLoading = false;
            });
        },
        addNewAct(){
            // 新增章
            let ajaxData = [];
            for (let i in this.$refs.addNewAct.inputData){
                if (this.$refs.addNewAct.inputData[i].value == ''){
                    this.$message.error('必填项不能为空');
                    this.confirmLoading = false;
                    return false;
                }
                let newObj = {};
                newObj.activityName = this.$refs.addNewAct.inputData[i].value;
                newObj.researchId = this.appUtils.getResearchId();
                // newObj.groupId = "5c8083a30f0445acb02514ced98c1ae8";
                newObj.userId = this.appUtils.getUserId();
                ajaxData.push(newObj);
            }


            this.http.post(this.apis.coursedetail.batchInsertActivityInfo, ajaxData).then(res => {
                console.log(res);
                this.$message.success('添加成功');
                this.visible = false;
                this.confirmLoading = false;
                this.initData();
            }).catch(err => {
                this.$message.error(err.message);
                this.confirmLoading = false;
            });
        },
        handleCancel(e) {
            this.visible = false;
        },
        initData(){
            this.http.get(this.apis.coursedetail.getResearchMessageById, {
                researchId: this.appUtils.getResearchId()
                // groupId: '5c8083a30f0445acb02514ced98c1ae8'
                // researchId: '893a90e4a4d24e60a66917a557306cbe',
                // groupId: 'd7ca4a1c90c74a77b19c829a5c359071'
            }).then(res => {
                console.log(res);
                this.$emit('getResearchMessageById');
                this.activityArr = [];
                if (res.data.activityInfoList.length > 0){
                    for (let i in res.data.activityInfoList){
                        let newSectionObj = res.data.activityInfoList[i];
                        newSectionObj.showDetail = true;
                        newSectionObj.checkbox = false;
                        let taskObj = [];
                        for (let p in res.data.activityInfoList[i].activityTasks){
                            let newTaskObj = res.data.activityInfoList[i].activityTasks[p];
                            newTaskObj.showDetail = true;
                            newTaskObj.checkbox = false;
                            let taskActObj = [];
                            for (let o in res.data.activityInfoList[i].activityTasks[p].taskActList){
                                let newTaskActObj = res.data.activityInfoList[i].activityTasks[p].taskActList[o];
                                newTaskActObj.checkbox = false;

                                taskActObj.push(newTaskActObj);
                            }
                            newTaskObj.taskActList = taskActObj;
                            taskObj.push(newTaskObj);
                        }
                        newSectionObj.activityTasks = taskObj;
                        this.activityArr.push(newSectionObj);
                    }
                }
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        togDetail(item){
            item.showDetail = !item.showDetail;
        },
        changedrag(newItem){
            this.drag = false;
            this.loading = true;
            let ajaxData = [];
            for (let i in this.activityArr){
                ajaxData.push(this.activityArr[i].activityId);
            }
            this.http.post(this.apis.coursedetail.updateActivitySort, ajaxData).then(res => {
                console.log(res);
                this.$message.success('排序成功');
                this.initData();
                this.loading = false;
            }).catch(err => {
                this.$message.error(err.message);
                this.loading = false;
            });
        },
        changedrag1(newItem){
            this.drag = false;
            this.loading = true;
            let ajaxData = [];
            for (let i in newItem.activityTasks){
                ajaxData.push(newItem.activityTasks[i].taskId);
            }
            this.http.post(this.apis.coursedetail.updateTaskSort, ajaxData).then(res => {
                console.log(res);
                this.$message.success('排序成功');
                this.initData();
                this.loading = false;
            }).catch(err => {
                this.$message.error(err.message);
                this.loading = false;
            });
        },
        changedrag2(newItem1, index1, index){
            console.log(newItem1.taskActList);
            this.drag = false;
            this.loading = true;
            this.$nextTick(function (){
                let newItem = this.activityArr[index].activityTasks[index1];
                let ajaxData = [];
                for (let i in newItem.taskActList){
                    ajaxData.push(newItem.taskActList[i].actId);
                }
                console.log(ajaxData);
                this.http.post(this.apis.coursedetail.updateActSort, ajaxData).then(res => {
                    console.log(res);
                    this.$message.success('排序成功');
                    this.initData();
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.message);
                    this.loading = false;
                });
            });
        },
        handleChangeSortType(sortType) {
            console.log(sortType);
            this.sortType = sortType;
            // if (info.file.status !== 'uploading') {
            //     console.log(info.file, info.fileList);
            // }
            // if (info.file.status === 'done') {
            //     this.$message.success(`${info.file.name} file uploaded successfully`);
            // } else if (info.file.status === 'error') {
            //     this.$message.error(`${info.file.name} file upload failed.`);
            // }
        },
        handleChange(qastoreType) {
            console.log(qastoreType);
            this.qastoreType = qastoreType;
            // if (info.file.status !== 'uploading') {
            //     console.log(info.file, info.fileList);
            // }
            // if (info.file.status === 'done') {
            //     this.$message.success(`${info.file.name} file uploaded successfully`);
            // } else if (info.file.status === 'error') {
            //     this.$message.error(`${info.file.name} file upload failed.`);
            // }
        },
        // 文件上传后回调
        changeUploadVideo(res){
            if (res.file){
                let fileList = [...res.fileList];
                fileList = fileList.slice(-1);
                this.fileListVideo = fileList;
                console.log(fileList);
                if (fileList.length > 0){
                    if (fileList[0].response){
                        console.log(fileList[0].response);
                        this.fileListVideoUrl = this.apis.upload.aliyuncs + '/' + fileList[0].response.data.filePath;
                    }
                }
            }
        },
        // 问卷上传后回调
        fileListVideoExcelImport1(res){
            console.log(res);
            // if (res.file){
            //     let fileList = [...res.fileList];
            //     fileList = fileList.slice(-1);
            //     this.fileListVideo = fileList;
            //     console.log(fileList);
            //     if (fileList.length > 0){
            //         if (fileList[0].response){
            //             console.log(fileList[0].response);
            //             this.fileListVideoUrl = this.apis.upload.aliyuncs + '/' + fileList[0].response.data.filePath;
            //         }
            //     }
            // }
        },
        customRequest(data){
            let file = data.file;
            if (file.name.indexOf('rar') > 0 || file.name.indexOf('zip') > 0 || file.name.indexOf('doc') > 0 || file.name.indexOf('docx') > 0 || file.name.indexOf('ppt') > 0 || file.name.indexOf('pptx') > 0 || file.name.indexOf('txt') > 0 || file.name.indexOf('xlsx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('pdf') > 0 || file.name.indexOf('DOC') > 0 || file.name.indexOf('DOCX') > 0 || file.name.indexOf('PPT') > 0 || file.name.indexOf('PPTX') > 0 || file.name.indexOf('TXT') > 0 || file.name.indexOf('XLSX') > 0 || file.name.indexOf('XLS') > 0 || file.name.indexOf('PDF') > 0 || file.name.indexOf('caj') > 0){
                const isLt2M = file.size/1024/1024 < 50;
                if (!isLt2M) {
                    this.$message.error('单个文件大小不超过50M!');
                    this.loading = false;
                    return false;
                }
            } else {
                fileList = [];
                this.$nextTick(function () {
                    this.fileListVideo = [];
                    this.loading = false;
                });
                this.$message.error('上传文件不符');
                return false;
            }
            return false;
        },
        transformFile(file){
            console.log(file);
            return new Promise(resolve => {
                resolve();
            });
        },
        // 文件上传前检测
        beforeUploadVideo(file, fileList){
            console.log(file);
            if (file.name.indexOf('rar') > 0 || file.name.indexOf('zip') > 0 || file.name.indexOf('doc') > 0 || file.name.indexOf('docx') > 0 || file.name.indexOf('ppt') > 0 || file.name.indexOf('pptx') > 0 || file.name.indexOf('txt') > 0 || file.name.indexOf('xlsx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('pdf') > 0 || file.name.indexOf('DOC') > 0 || file.name.indexOf('DOCX') > 0 || file.name.indexOf('PPT') > 0 || file.name.indexOf('PPTX') > 0 || file.name.indexOf('TXT') > 0 || file.name.indexOf('XLSX') > 0 || file.name.indexOf('XLS') > 0 || file.name.indexOf('PDF') > 0 || file.name.indexOf('caj') > 0){
                const isLt2M = file.size/1024/1024 < 50;
                if (!isLt2M) {
                    this.$message.error('单个文件大小不超过50M!');
                    this.loading = false;
                    return false;
                }

                // let formData = new FormData();

                // // const reader = new FileReader();
                // // reader.readAsDataURL(file);
                // // reader.onload = () => {
                // //     console.log(reader);
                // //     console.log(reader.result);
                //     formData.append('file', file);
                //     console.log(formData);
                //     this.http.post(this.apis.upload.apiUpload+this.appUtils.getResearchId(), formData).then(res => {

                //     }).catch(err => {
                //         // this.$message.error('上传失败');
                //         this.loading = false;
                //     })
                // // };
            } else {
                fileList = [];
                this.$nextTick(function () {
                    this.fileListVideo = [];
                    this.loading = false;
                });
                this.$message.error('上传文件不符');
                return false;
            }

            // return false;
        },

        // 视频上传前检测
        beforeUploadVideo11(file, fileList){
            // mp4、wmv、avi、rmvb
            if (
                file.name.toLocaleLowerCase().indexOf('jpg') > 0 ||
                file.name.toLocaleLowerCase().indexOf('png') > 0 ||
                file.name.toLocaleLowerCase().indexOf('ppt') > 0 ||
                file.name.toLocaleLowerCase().indexOf('pptx') > 0 ||
                file.name.toLocaleLowerCase().indexOf('xls') > 0 ||
                file.name.toLocaleLowerCase().indexOf('xlsx') > 0 ||
                file.name.toLocaleLowerCase().indexOf('doc') > 0 ||
                file.name.toLocaleLowerCase().indexOf('docx') > 0 ||
                file.name.toLocaleLowerCase().indexOf('pdf') > 0
            ){
                const isLt2M = file.size/1024/1024 < 10;
                if (!isLt2M) {
                    this.$message.error('单个文件大小不超过10M!');
                    this.loading = false;
                    return false;
                }
            } else {
                fileList = [];
                this.$nextTick(function () {
                    this.fileListVideo1 = [];
                    this.loading = false;
                });
                this.$message.error('上传文件不符');
                return false;
            }

        },
        // 文件上传前检测
        beforeUploadVideoExcelImport(file, fileList){
            console.log(file);
            if (file.name.indexOf('xlsx') > 0 || file.name.indexOf('xls') > 0 || file.name.indexOf('XLSX') > 0 || file.name.indexOf('XLS') > 0){
                const isLt2M = file.size/1024/1024 < 50;
                if (!isLt2M) {
                    this.$message.error('单个文件大小不超过50M!');
                    this.loading = false;
                    return false;
                }

                var formFile = new FormData();
                formFile.append('file', file);

                this.http.postFormData(this.apis.coursedetail.excelImport, formFile).then(res => {
                    console.log(res);
                    this.voteSubjectList = res.data.voteSubjectList;
                    this.voteImport = '';
                    this.loading = false;

                    if (res.data.voteSubjectList.length == 0){
                        this.$message.error('上传文件失败');
                        this.voteImportDisable = true;
                    } else {
                        this.$message.success('上传文件成功');
                        this.voteImportDisable = false;
                    }
                }).catch(err => {
                    this.$message.error('上传文件失败');
                    this.loading = false;
                    this.voteImportDisable = true;
                });

            } else {
                fileList = [];
                this.$nextTick(function () {
                    this.fileListVideoExcelImport = [];
                    this.loading = false;
                });
                this.$message.error('上传文件不符');
                return false;
            }

            return false;
        },
        previewFile(){
            console.log(this.fileListVideoUrl);
            if (this.fileListVideoUrl){
                window.open(this.apis.preview + this.fileListVideoUrl);
            } else {
                this.$message.error('无预览的文件');
            }
        },

        log(value) {
            console.log(value);
        },
        // 视频上传后回调
        changeUploadVideo1(res){
            this.loading = true;
            console.log(res.file);
            if (res.file){

            } else {
                this.loading = false;
            }
        },
        getJobDone(resData){
            let ajaxData = {};
            ajaxData.jobId = resData.ldJobId;
            this.http.get(this.apis.coursedetail.checkJobDone, ajaxData).then(res => {
                console.log(res);
                let resJobData = res.data;
                console.log(resJobData[0].percent);
                if (resJobData[0].percent < 100){
                    let that = this;
                    let time = setTimeout(function (){
                        that.getJobDone(resData);
                    },1000);
                } else if (resJobData[0].percent >= 100){
                    this.videoSrc = resData.ldUrl;
                    this.videoElement = this.$refs.video;
                    // this.videoSrc = resData.ysUrl;
                    this.ysUrl = resData.ysUrl;
                    this.fdUrl = resData.fdUrl;
                    this.hdUrl = resData.hdUrl;
                    this.ldUrl = resData.ldUrl;
                    this.sdUrl = resData.sdUrl;
                    this.$message.success('转码成功');
                    this.loading = false;
                }
            }).catch(err => {
                this.$message.error('转码失败');
                this.loading = false;
            });
        },
        getExtension(filename) {
            // 使用 "." 分割字符串
            const parts = filename.split('.');
            // 获取最后一个元素作为扩展名
            const extension = '.' + parts[parts.length - 1];
            return extension;
        },
        // 视频上传前检测
        beforeUploadVideo1(file, fileList){
            // mp4、wmv、avi、rmvb
            if (file.name.indexOf('mp4') > 0 || file.name.indexOf('wmv') > 0 || file.name.indexOf('avi') > 0 || file.name.indexOf('rmvb') > 0 || file.name.indexOf('MP4') > 0 || file.name.indexOf('WMV') > 0 || file.name.indexOf('AVI') > 0 || file.name.indexOf('RMVB') > 0){
                // if (/^[\w\u4E00-\u9FA5\uF900-\uFA2D]*$/.test(file.name)){
                // if (/^[\w\u4E00-\u9FA5\uF900-\uFA2D\-\_]*$/.test(file.name.split('.').splice(0,file.name.split('.').length-1).join('.'))){
                    this.playerShow = false;
                    this.$nextTick(function () {
                        this.playerShow = true;
                        this.initAliPlayer('', '', '', '', '', '', '', 0);
                    });
                    // console.log("执行上传");

                    this.uploader.addFile(file, 'https://oss-cn-shenzhen.aliyuncs.com', this.apis.upload.bucketName, 'class/make/video/Ys-mask-video/'+this.appUtils.getResearchId() + '/' + (new Date()).getTime() + this.getExtension(file.name), '');
                    this.uploader.startUpload();
                    this.player = '';
                    this.playerShow = false;
                    // let getMediaIdByOssUrlUrl = 'http://yjyp-test-video-file.oss-cn-shenzhen.aliyuncs.com/class/make/video/Ys-mask-video/0accf6f5f59c481ab7fd22cad07e8b40/6.28.mp4';
                    // this.http.get(this.apis.coursedetail.getMediaIdByOssUrl, {
                    //     ossUrl: getMediaIdByOssUrlUrl
                    // }).then(res => {
                    //     console.log(res);
                    //     this.http.get(this.apis.coursedetail.getPlayerParamByMediaId+ '/'+res.data.MediaId, {
                    //     }).then(res => {
                    //         console.log(res);
                    //     }).catch(err => {
                    //         this.$message.error('获取媒体id失败');
                    //     })
                    // }).catch(err => {
                    //     this.$message.error('获取媒体id失败');
                    // })
                // } else {
                //     fileList = [];
                //     this.$nextTick(function () {
                //         this.fileListVideo1 = [];
                //         this.loading = false;
                //     });
                //     this.$message.error('文件名不能含有标点符号,如 !@#$%^&*()。空格 等');
                //     return false;
                // }
            } else {
                fileList = [];
                this.$nextTick(function () {
                    this.fileListVideo1 = [];
                    this.loading = false;
                });
                this.$message.error('上传文件不符');
                return false;
            }
            const isLt2M = file.size/1024/1024 < 3000;
            if (!isLt2M) {
                this.$message.error('单个文件大小不超过3000M!');
                this.loading = false;
                return false;
            }
            return false;
        },
        // 旧资源库
        // getResource1(){
        //     this.loading = true;
        //     this.actInfoShow1 = true;
        //     let ajaxData = {
        //         "where":{
        //             "name_like":this.appUtils.getReaserchInfo().researchName + '_',
        //             // "name_like":'',
        //             "status_eq":"3",
        //             "resourceType_in":"8,9,10,11,12"
        //         },
        //         "pageSize":10000
        //     };
        //     this.http.post(this.apis.coursedetail.resource, ajaxData).then(res => {
        //         this.resourceArr = res.data;
        //         this.loading = false;
        //     }).catch(err => {
        //         this.$message.error(err.message);
        //     })
        // },
        // getResource(){
        //     this.loading = true;
        //     this.actInfoShow1 = true;
        //     let ajaxData = {
        //         "where":{
        //             "name_like":this.appUtils.getReaserchInfo().researchName + '_',
        //             // "name_like":'',
        //             "status_eq":"3",
        //             "resourceType_eq":"13"
        //         },
        //         "pageSize":10000
        //     };
        //     this.http.post(this.apis.coursedetail.resource, ajaxData).then(res => {
        //         this.resourceArr = res.data;
        //         this.loading = false;
        //     }).catch(err => {
        //         this.$message.error(err.message);
        //     })
        // },
        getResource1(){
            this.loading = true;
            this.actInfoShow1 = true;
            let url = this.apis.coursedetail.getResource+'?status=3&resourceType=8,9,10,11,12';

            this.http.post(url, {
                keyword: this.appUtils.getReaserchInfo().researchName
            }).then(res => {
                this.resourceArr = res.data;
                this.loading = false;
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        getResource(){
            this.loading = true;
            this.actInfoShow1 = true;
            let url = this.apis.coursedetail.getResource+'?status=3&resourceType=13';

            this.http.post(url, {
                keyword: this.appUtils.getReaserchInfo().researchName
            }).then(res => {
                this.resourceArr = res.data;
                this.loading = false;
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        chooseThis(item){
            console.log(item);
            if (item.name.indexOf('_cha')>-1){
              this.remark = 'cha';
            } else if (item.name.indexOf('_klgm')>-1){
              this.remark = 'klgm';
            }
            // 阅读
            if (this.actTypeIdArr[this.actTypeId].popShowtzyd){
                this.fileListVideoUrl = item.url;
                // this.filename = item.name;
                this.fileListVideo = [{
                    uid: '1',
                    name: item.name,
                    status: 'done',
                    url: item.url
                }];
                this.actInfoShow1 = false;
                this.$message.success('已选中，请继续编辑活动');
            }

            // 视频
            if (this.actTypeIdArr[this.actTypeId].popShowspxx){
                if (item.runId){
                    this.actInfoShow1 = false;
                    this.aliYsUrl = item.url;
                    this.getMediaWorkflowExecutionByRunId(item.runId);
                    this.$message.success('已选中，请继续编辑活动');
                } else {
                    this.$message.error('找不到该资源视频');
                }
            }
        },
        chooseQuestion(){
            console.log(this.player);
            if (!this.playerShow){
                this.$message.error('视频未加载完');
                return;
            }
            if (!this.player){
                this.$message.error('视频未加载完');
                return;
            }
            this.player.pause();
            // video
            this.actInfoShow2 = true;
            this.keyWord = '';
            this.qastoreContent = '';
            this.qastoreType = '';
            this.selectedRows = [];
            this.pagination.currentPage = 1;
            this.pagination.total = 10;
            this.pagination.pageSize = 10;
            this.videoElement = this.$refs.video;
            this.tableData = [];
            // this.videoElement.pause();
            this.videoNowTime = this.formateSeconds(this.player.getCurrentTime());
            this.h = this.videoNowTime.h;
            this.min = this.videoNowTime.min;
            this.secondTime = this.videoNowTime.secondTime;
            this.hm = this.videoNowTime.hm;
            this.selectedRows = [];
            this.$nextTick(function () {
                this.searchQastoreList();
            });
        },
        formateSeconds(endTime){
            let secondTime = parseInt(endTime);//将传入的秒的值转化为Number
            let min = 0;// 初始化分
            let h =0;// 初始化小时
            let result='';
            if (secondTime>60){ //如果秒数大于60，将秒数转换成整数
                min=parseInt(secondTime/60);//获取分钟，除以60取整数，得到整数分钟
                secondTime=parseInt(secondTime%60);//获取秒数，秒数取佘，得到整数秒数
                if (min>60){ //如果分钟大于60，将分钟转换成小时
                h=parseInt(min/60);//获取小时，获取分钟除以60，得到整数小时
                min=parseInt(min%60); //获取小时后取佘的分，获取分钟除以60取佘的分
                }
            }
            let hm = endTime.toString().split('.')[1];
            if (hm){
                if (hm.length > 3){
                    hm = hm.slice(0, 3);
                } else {
                    hm = hm.padEnd(3, '0');
                }
            }
            result=`${h.toString().padStart(2,'0')}:${min.toString().padStart(2,'0')}:${secondTime.toString().padStart(2,'0')}.${hm ||'000'}`;
            let timeData = {};
            timeData.result = result;
            timeData.h = h.toString().padStart(2,'0');
            timeData.min = min.toString().padStart(2,'0');
            timeData.secondTime = secondTime.toString().padStart(2,'0');
            timeData.hm = hm || '000';
            return timeData;
        },
        searchQastoreList(){
            // searchQastoreList
            let ajaxData = {};
            ajaxData.currentPage = this.pagination.currentPage;
            ajaxData.pageSize = this.pagination.pageSize;
            ajaxData.researchId = this.appUtils.getResearchId();
            if (this.keyWord){
                ajaxData.keyWord = this.keyWord;
            }
            if (this.qastoreContent){
                ajaxData.qastoreContent = this.qastoreContent;
            }
            ajaxData.qastoreType = this.qastoreType;
            ajaxData.sortType = this.sortType;
            console.log(ajaxData);
            this.http.get(this.apis.coursedetail.searchQastoreList, ajaxData).then(res => {
                this.tableData = res.data;
                this.pagination.currentPage = res.pageInfo.currentPage;
                this.pagination.total = res.pageInfo.totalCount;
                this.pagination.pageSize = res.pageInfo.pageSize;
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        handleQuestionTableChange(pagination){
            this.pagination.pageSize=pagination.pageSize;
            this.pagination.currentPage=pagination.current;
            this.searchQastoreList();
        },
        courseQuestionBankhandleOk(){
            this.courseQuestionBankvisible = false;
        },
        courseQuestionBankhandleCancel(){
            this.courseQuestionBankvisible = false;
        }
    },
    computed: {
        dragOptions(){
            return {
                animation: 200,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost'
            };
        },
        dragOptions1(){
            return {
                animation: 200,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost'
            };
        },
        dragOptions2(){
            return {
                animation: 200,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost'
            };
        },
        dragOptions3(){
            return {
                animation: 200,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost'
            };
        },
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedRows = selectedRows;
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: record.name === 'Disabled User', // Column configuration not to be checked
                        name: record.name
                    }
                })
            };
        }
        // h
        // min: '',
        // secondTime: '',
        // hm: '',
    },
    watch: {
        min: function (val) {
            if (val > 59){
                this.min = 59;
            }
            if (val < 0){
                this.min = 0;
            }
        },
        secondTime: function (val) {
            if (val > 59){
                this.secondTime = 59;
            }
            if (val < 0){
                this.secondTime = 0;
            }
        },
        hm: function (val) {
            if (val > 999){
                this.hm = 999;
            }
            if (val < 0){
                this.hm = 0;
            }
        }
    }
};
</script>

<style lang="less">
.draggablecheckbox{
    display: inline-block;
    transform: translate(0px, 4px);
    margin: 0 8px 0 5px;
}
.draggablecheckbox1{
    display: inline-block;
    margin: 0 8px 0 4px;
}
.button {
    margin-top: 35px;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    min-height: 20px;
}
.list-group-item {
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
.componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    padding: 25px 40px;
}
.componentText{
    font-size: 30px;
    color: #333333;
}
.actWrap{
    // min-height: calc(100vh);
    user-select:none;
    .actListStyle > div{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
        align-items: center;
        width: 840px;
        height: 60px;
        border:1px solid #EBEBEB;
        box-shadow:0px 4px 6px #EBEBEB;
        border-radius: 5px;
        margin: 10px auto;
        color: #999999;
        .actTypeIdStyle{
            margin-left: 5px;
            width: 70px;
            text-align: left;
            display: inline-block;
        }
        .actNameStyle{
            font-size: 14px;
            color: #333333;
            width: 370px;
            text-overflow:ellipsis;
            overflow:hidden;
            text-align: left;
            white-space:nowrap;
        }
        .needTypeCodeYStyle{
            display: inline-block;
            background-color: #1890FF;
            border: 1px solid #1890FF;
            color: white;
            padding: 4px 9px;
            border-radius: 3px;
        }
        .needTypeCodeNStyle{
            display: inline-block;
            background-color: #EBEBEB;
            border: 1px solid #D9D9D9;
            color: #909090;
            padding: 4px 9px;
            border-radius: 3px;
        }
        .actHandle{
            font-size: 20px;
            cursor: pointer;
        }
    }
    .actAdd{
        height: 60px;
        background-color: #FAFAFA;
        line-height: 60px;
        border: 1px dashed #D9D9D9;
        border-radius: 5px;
        margin: 20px 40px;
        max-width: 1080px;
        cursor: pointer;
        color: #999999;
    }
}
.section{
    border-radius:4px;
    margin: 20px 40px;
    padding-bottom: 20px;
    width: 1080px;
    min-height: 60px;
    border:1px solid #E8E8E8;
    box-shadow:0px 4px 12px #EEEEEE;
    .sectionWrap{
        height: 60px;
        padding: 0 30px;
        .sectionLeft{
            & > *{
                font-size: 14px;
                color: #666;
            }
            span{
                font-size: 14px;
                color: #333;
                text-align: left;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                max-width: 840px;
            }
        }
        .sectionRight{
            font-size: 20px;
            & > *{
                color: #999;
                margin: 0 5px;
            }
        }
        .isDisplayN{
            margin: 0 10px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            max-width: 820px;
        }
    }
    .taskWrap{
        height: 46px;
        padding: 0 5px 0 10px;
        margin: 0 27px 0 45px;
        background-color: #FAFAFA;
        border: 1px solid #E9E9E9;
        .sectionRight{
            font-size: 16px;
        }
    }
    .taskWrap1{
        height: 46px;
        margin: 0 27px 0 45px;
        padding: 0 5px 0 30px;
        border-left: 1px solid #E9E9E9;
        border-right: 1px solid #E9E9E9;
        position: relative;
        .sectionRight{
            font-size: 16px;
        }
        &:hover{
            background-color: #E6F7FF;
        }
        &:nth-last-of-type(1):after{
            border-top: none;
        }
        &:after{
            content: '';
            width: calc(100% - 30px);
            position: absolute;
            bottom: 0px;
            right: 0;
            transform: translate(0%, -50%);
            border-top: 1px solid #E8E8E8;
        }
    }
    .emptyWrap{
        color: #ccc;
        font-size: 20px;
        padding: 15px 0;
        border-left: 1px solid rgb(233, 233, 233);
        border-right: 1px solid rgb(233, 233, 233);
        span{
            font-size: 14px;
            color: #999;
        }
    }
}
.actAddWrap{
    .actAddText{
        color: #999999;
    }
    .actAddList{
        padding: 25px 0 50px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        .actAddListDiv{
            flex: 0 1 25%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: center;
        }
    }
}
.resourceList{
    border-bottom: 1px solid #E8E8E8;
    line-height: 50px;
    padding: 0 20px;
    .resourceLeft{
        font-size: 16px;
        width: 80%;
        // overflow: hidden;
        // text-overflow:ellipsis;
        // white-space: nowrap;
    }
    .resourceRight{
        font-size: 16px;
        width: 15%;
    }
}
.questionList{
    .questionListTop{
        text-align: center;
        border: 1px solid #ececec;
        line-height: 60px;
        background: #FAFAFA;
    }
    .questionListList{
        text-align: center;
        & > *{
            padding: 30px 10px;
        }
    }
}
.question{
    .questionTop{
        background-color: #FAFAFA;
        padding: 15px 0;
        & > *{
            margin: 0 3px;
        }
        input{
            width: 50px;
            padding: 0;
            text-align: center;
        }
    }
}
.actFormWrap{
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
}
.df{
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
}
.dfc{
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
}
.dfrn{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
}
.dfrnsa{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
}
.dfcc{
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
}
.requiredForm .ant-form-item-label::before{
    content: '*';
    color: red;
    margin-right: 5px;
}
.w10{
    width: 10%;
}
.w15{
    width: 15%;
}
.w20{
    width: 20%;
}
.w30{
    width: 30%;
}
.w40{
    width: 40%;
}
.w50{
    width: 50%;
}
.w60{
    width: 60%;
}
.w80{
    width: 80%;
}
.w85{
    width: 85%;
}
.w100{
    width: 100%;
}
.w5p{
    width: 5px;
}
.w10p{
    width: 10px;
}
.w300p{
    width: 300px;
}
.dib{
    display: inline-block;
}
.db{
    display: block;
}
.mab10{
    margin-bottom: 10px;
}
.mab20{
    margin-bottom: 20px;
}
.f20{
    font-size: 20px;
}
.f22{
    font-size: 22px;
}
.cp{
    cursor: pointer;
}
.cccc{
    color: #ccc;
}
.hoverc666:hover{
    color: #666;
}
.example {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 0;
    z-index: 1001;
    & > * {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
.uploadBtn{
    margin: 20px 0;
    & > *{
        margin-right: 20px;
    }
}
.prism-player .prism-setting-list .prism-setting-item:nth-of-type(1), .prism-player .prism-setting-list .prism-setting-item:nth-of-type(2), .prism-player .prism-setting-list .prism-setting-item:nth-of-type(3){
    display: none;
}
</style>
